import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TablePagination,
  TextField,
  Typography,
  IconButton,
  Button,
  Tooltip,
  LinearProgress,
  Popover,
  List,
  ListItemButton,
  ListItemText,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import jsPDF from "jspdf";
import { appendSanitizedReportHtml } from "../../utils/reportSanitizer";
import html2canvas from "html2canvas";
import morningImg from "../../images/icons8-sunrise-48.png";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import afternoonImg from "../../images/afternoon.png";
import eveningImg from "../../images/icons8-sunset-48 (1).png";
import nightImg from "../../images/night.png";
import PrintIcon from "@mui/icons-material/Print";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import ReceiptIcon from "@mui/icons-material/Receipt";
import JsBarcode from "jsbarcode";
import blankA4 from "../../pdf/blankA4.pdf";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import RefreshIcon from "@mui/icons-material/Refresh";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import DeleteIcon from "@mui/icons-material/Delete";
import DifferenceIcon from "@mui/icons-material/Difference";
//import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import EastIcon from "@mui/icons-material/East";
import { BASE_URL } from "../../constants";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { toast } from "react-toastify";
import { pxToPdfPosition } from "./pxToPdfPosition";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import { Edit } from "@mui/icons-material";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";

const APPOINTMENT_STATUSES = {
  booked: {
    label: "Appointment booked",
    shortLabel: "Booked",
    color: "#2563eb",
    background: "#eff6ff",
    border: "#bfdbfe",
  },

  arrived: {
    label: "Patient arrived in clinic",
    shortLabel: "Arrived",
    color: "#b45309",
    background: "#fffbeb",
    border: "#fde68a",
  },

  in_consult: {
    label: "Patient in consult",
    shortLabel: "In consult",
    color: "#047857",
    background: "#ecfdf5",
    border: "#a7f3d0",
  },

  pending: {
    label: "Prescription on hold",
    shortLabel: "On Hold",
    color: "#c2410c",
    background: "#fff7ed",
    border: "#fed7aa",
  },
};

const getAppointmentStatus = (appointment) => {
  const status = String(appointment?.appointmentStatus || "")
    .trim()
    .toLowerCase();

  if (status === "pending") return "pending";
  if (status === "arrived") return "arrived";
  if (status === "in_consult") return "in_consult";
  if (status === "completed") return "completed";

  return "booked";
};
const getFormattedCurrentDate = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("en-US", { month: "long" });
  const year = today.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${month} ${formattedDay}, ${year}`;
};
const formatDateToReadableString = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;
  return `${month} ${formattedDay}, ${year}`;
};
const getFormattedDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0]; // Extracts YYYY-MM-DD from ISO format
};
const AppointmentList = ({ appointments, setAppointments }) => {
  const user = useRecoilValue(authState);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  //const [date, setDate] = useState(null);
  const [date, setDate] = useState(new Date());
  const [fromDate, setFromDate] = useState(getFormattedDate());
  const [toDate, setToDate] = useState(getFormattedDate());
  const [formattedFromDate, setFormattedFromDate] = useState(
    getFormattedCurrentDate(),
  );
  const [formattedToDate, setFormattedToDate] = useState(
    getFormattedCurrentDate(),
  );
  // const fetchAppointments = async () => {
  //   setLoading(true);
  //   setDate(null);
  //   try {
  //     const query = `${BASE_URL}api/user/get-upcoming-appointments`;

  //     const response = await fetch(query, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     const data = await response.json();

  //     if (data.success) {
  //       setAppointments(data.data);
  //     } else {
  //       setAppointments([]);
  //       //alert(data.message || "No appointments found");
  //     }
  //   } catch (error) {
  //     alert("Something went wrong! Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    const dt = dayjs(fromDate).format("YYYY/MM/DD");
    fetchAppointmentsByDate(dt);
    fetchPdfTemplate();
  }, []);

  const handleReload = () => {
    const dt = dayjs(fromDate).format("YYYY/MM/DD");
    fetchAppointmentsByDate(dt);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
    setPage(0);
  };

  const fetchAppointmentsByDate = async (selectedDate) => {
    setLoading(true);
    try {
      const query = `${BASE_URL}api/user/opd/get-appointments?startDate=${formattedFromDate}&endDate=${formattedToDate}`;

      const response = await fetch(query, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data.success) {
        setAppointments(data.data);
      } else {
        setAppointments([]);
        //alert(data.message || "No appointments found");
      }
    } catch (error) {
      alert("Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const searchByDate = () => {
    const dt = dayjs(fromDate).format("YYYY/MM/DD");
    fetchAppointmentsByDate(dt);
  };
  const filteredAppointments = appointments.filter((appointment) => {
    const { patientId, doctorId, centreId, appDate, appTime, appointmentId } =
      appointment;
    return (
      patientId?.name.toLowerCase().includes(searchQuery) ||
      doctorId?.name.toLowerCase().includes(searchQuery) ||
      centreId?.centreName.toLowerCase().includes(searchQuery) ||
      appDate?.toLowerCase().includes(searchQuery) ||
      appTime?.toLowerCase().includes(searchQuery) ||
      appointmentId?.toLowerCase().includes(searchQuery)
    );
  });

  const paginatedAppointments = filteredAppointments.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  const [statusUpdatingId, setStatusUpdatingId] = useState(null);

  const updateAppointmentStatus = async (appointment, nextStatus) => {
    const currentStatus = getAppointmentStatus(appointment);
    if (!appointment?._id || currentStatus === nextStatus) return;

    setStatusUpdatingId(appointment._id);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/opd/update-appointment/${appointment._id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            appointmentStatus: nextStatus,
          }),
        },
      );
      const result = await response.json();
      if (!response.ok || !result.success) {
        throw new Error(
          result.message || "Unable to update appointment status",
        );
      }

      setAppointments((current) =>
        current.map((item) =>
          item._id === appointment._id
            ? {
                ...item,
                status: result.data?.status || nextStatus,
                appointmentStatus: result.data?.appointmentStatus || nextStatus,
              }
            : item,
        ),
      );
      toast.success(
        `Status updated to ${APPOINTMENT_STATUSES[nextStatus].label}`,
      );
    } catch (error) {
      toast.error(error.message || "Unable to update appointment status");
    } finally {
      setStatusUpdatingId(null);
    }
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this appointment?",
    );
    if (!isConfirmed) {
      return;
    }
    try {
      const response = await fetch(
        `${BASE_URL}api/user/opd/delete-appointment/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      if (data.success) {
        alert(data.message);
        setAppointments(appointments.filter((app) => app._id !== id));
      } else {
        alert(`Error: ${data.message}`);
      }
    } catch (error) {
      alert("An unexpected error occurred while deleting the patient.");
    }
  };

  const handleEditDigitalPress = async (appointmentId) => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/prescription/${appointmentId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch prescription");
      }

      const data = result.data;

      console.log("Fetched Prescription:", data);
      const prescription = {
        appointmentId,
        patient: data?.patientId,
        appId: data?.appointmentId?.appointmentId,
        investigations: data?.investigations,
        medicines: data?.medicines,
        symptoms: data?.symptoms,
        vitals: data?.vitals,
      };
      navigate("/dashboard/prescription", {
        state: {
          editMode: true,
          prescriptionData: prescription,
        },
      });
    } catch (error) {
      console.error("Error:", error.message);
      alert(error.message);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const monthAbbr = date.toLocaleString("en-US", { month: "short" });
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${monthAbbr}-${year}`;
  };

  const calculateAge = (dob) => {
    const birthDate = dayjs(dob, "MMMM DD, YYYY");
    const today = dayjs();

    const years = today.diff(birthDate, "year");
    const months = today.diff(birthDate.add(years, "year"), "month");
    const days = today.diff(
      birthDate.add(years, "year").add(months, "month"),
      "day",
    );
    return `${years}Y ${months}M ${days}D`;
  };

  const [pdfTemplate, setPdfTemplate] = useState("");
  const fetchPdfTemplate = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-pdfTemplate-appoint`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      setPdfTemplate(data.pdf.docAppointPdfUrl);
    } catch (error) {}
  };

  const [pressLoading, setPressLoading] = useState(false);
  const [vitalsAppointment, setVitalsAppointment] = useState(null);
  const [vitals, setVitals] = useState({
    height: "",
    weight: "",
    pulse: "",
    bp: "",
  });
  const [savingVitals, setSavingVitals] = useState(false);

  const openVitalsDialog = (appointment) => {
    setVitalsAppointment(appointment);
    setVitals({
      height: appointment?.vitals?.height || "",
      weight: appointment?.vitals?.weight || "",
      pulse: appointment?.vitals?.pulse || "",
      bp: appointment?.vitals?.bp || "",
    });
  };

  const closeVitalsDialog = () => {
    if (!savingVitals) setVitalsAppointment(null);
  };

  const saveVitals = async () => {
    if (!vitalsAppointment?._id) return;

    setSavingVitals(true);

    try {
      if (!vitalsAppointment?.hasVitals) {
        const response = await fetch(
          `${BASE_URL}api/user/common/save-vitals/${vitalsAppointment._id}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ vitals }),
          },
        );
        const result = await response.json();
        if (!response.ok || !result.success) {
          throw new Error(result.message || "Unable to save vitals");
        }

        setAppointments((current) =>
          current.map((appointment) =>
            appointment._id === vitalsAppointment._id
              ? { ...appointment, vitals: result.data?.vitals || vitals }
              : appointment,
          ),
        );
        toast.success("Patient vitals saved");
        setVitalsAppointment(null);
      } else {
        const response = await fetch(
          `${BASE_URL}api/user/common/update-vitals/${vitalsAppointment._id}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ vitals }),
          },
        );
        const result = await response.json();
        if (!response.ok || !result.success) {
          throw new Error(result.message || "Unable to update vitals");
        }

        setAppointments((current) =>
          current.map((appointment) =>
            appointment._id === vitalsAppointment._id
              ? { ...appointment, vitals: result.data?.vitals || vitals }
              : appointment,
          ),
        );
        toast.success("Patient vitals saved");
        setVitalsAppointment(null);
      }
    } catch (error) {
      toast.error(error.message || "Unable to save patient vitals");
    } finally {
      setSavingVitals(false);
    }
  };

  const printPress = async (appointment, template) => {
    console.log("333333", appointment);
    setPressLoading(true);
    try {
      //const templateUrl = `${pdfTemplate}`;
      let templateUrl;
      if (template === 0) {
        templateUrl = blankA4;
      } else {
        if (appointment?.doctorId?.whichAppointmentTemplate === "doctor") {
          templateUrl = appointment?.doctorId?.appointmentTemplate?.pdfUrl;
        } else {
          templateUrl = `${pdfTemplate}`;
        }
      }
      const existingPdfBytes = await fetch(templateUrl).then((res) =>
        res.arrayBuffer(),
      );
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const firstPage = pages[0];

      const pageHeight = firstPage.getHeight();
      console.log("pageHeight", pageHeight);
      //Doctor Info
      let doctorInfoX; // = 15.43423;
      let doctorInfoY; // = 810;

      //Patient Info
      let patientInfoLeftX; // = 170;
      let patientInfoLeftY; // = 685;
      let patientInfoRightX; // = 400;
      let patientInfoRightY; // = 685;

      //note
      let noteY; // = 83;
      let noteX; //  = 172;

      let fontSizeD = 16;
      console.log(doctorInfoX, doctorInfoY);
      console.log("@@@@@", appointment?.doctorId?.appointmentTemplate);
      if (
        appointment?.doctorId?.whichAppointmentTemplate === "org" ||
        appointment?.doctorId?.whichAppointmentTemplate === "doctor"
      ) {
        //Patient Info
        patientInfoLeftX = Number(
          appointment?.doctorId?.appointmentTemplate?.patientInfoLeftX,
        );
        patientInfoLeftY = Number(
          pageHeight -
            appointment?.doctorId?.appointmentTemplate?.patientInfoLeftY -
            10,
        );
        patientInfoRightX = Number(
          appointment?.doctorId?.appointmentTemplate?.patientInfoRightX,
        );
        patientInfoRightY = Number(
          pageHeight -
            appointment?.doctorId?.appointmentTemplate?.patientInfoRightY -
            10,
        );
        //Doctor Info
        doctorInfoX = Number(
          appointment?.doctorId?.appointmentTemplate?.doctorX,
        );
        doctorInfoY = Number(
          pageHeight - appointment?.doctorId?.appointmentTemplate?.doctorY - 13,
        );

        //note
        noteY = Number(
          pageHeight - appointment?.doctorId?.appointmentTemplate?.noteY - 15,
        );
        noteX = Number(appointment?.doctorId?.appointmentTemplate?.noteX);

        console.log(doctorInfoX, doctorInfoY);
      }
      if (appointment?.doctorId?.appointmentTemplate?.doctorInfo === "yes") {
        firstPage.drawText(appointment?.doctorId?.name, {
          x: doctorInfoX,
          y: doctorInfoY,
          size: fontSizeD,
          font: boldFont,
          color: rgb(0.58, 0.212, 0.204),
        });
        doctorInfoY -= 15;
        appointment?.doctorId?.qualifications.forEach((qualification) => {
          firstPage.drawText(qualification, {
            x: doctorInfoX,
            y: doctorInfoY,
            size: fontSizeD - 5,
            font: boldFont,
            color: rgb(0, 0, 0),
          });
          doctorInfoY -= 15;
        });
      }
      if (appointment?.doctorId?.appointmentTemplate?.doctorNote === "yes") {
        if (appointment?.doctorId?.note) {
          firstPage.drawText(appointment?.doctorId?.note, {
            x: noteX,
            y: noteY,
            size: fontSizeD - 7,
            font: boldFont,
            color: rgb(0.388, 0.141, 0.137),
          });
          noteY += 13;
        }
      }
      if (appointment?.doctorId?.appointmentTemplate?.appNote === "yes") {
        if (appointment?.note) {
          firstPage.drawText(appointment?.note || "", {
            x: noteX,
            y: noteY, //y,
            size: fontSizeD - 7,
            font: boldFont,
            color: rgb(0.388, 0.141, 0.137),
          });
        }
      }
      let fontSize = 11;
      console.log(patientInfoLeftX);
      console.log(patientInfoLeftY);
      firstPage.drawText(appointment?.patientId?.name, {
        x: patientInfoLeftX,
        y: patientInfoLeftY,
        size: fontSize + 1,
        font: boldFont,
        color: rgb(0, 0, 0),
      });
      firstPage.drawText("UHID: " + appointment?.patientId?.patientID, {
        x: patientInfoRightX,
        y: patientInfoRightY,
        size: fontSize + 1,
        font: boldFont,
        color: rgb(0, 0, 0),
      });
      patientInfoLeftY -= 15;
      patientInfoRightY -= 15;
      firstPage.drawText(
        "Sex/Age: " +
          appointment?.patientId?.gender +
          " / " +
          calculateAge(appointment?.patientId?.dob),
        {
          x: patientInfoLeftX,
          y: patientInfoLeftY,
          size: fontSize - 1,
          font: font,
          color: rgb(0, 0, 0),
        },
      );
      firstPage.drawText("Appointment ID: " + appointment?.appointmentId, {
        x: patientInfoRightX,
        y: patientInfoRightY,
        size: fontSize - 1,
        font: font,
        color: rgb(0, 0, 0),
      });
      patientInfoLeftY -= 15;
      patientInfoRightY -= 15;
      firstPage.drawText("Mobile: " + appointment?.patientId?.mobile, {
        x: patientInfoLeftX,
        y: patientInfoLeftY,
        size: fontSize - 1,
        font: font,
        color: rgb(0, 0, 0),
      });
      firstPage.drawText(
        "Appointment Date: " + formatDate(appointment.appDate),
        {
          x: patientInfoRightX,
          y: patientInfoRightY,
          size: fontSize - 1,
          font: font,
          color: rgb(0, 0, 0),
        },
      );
      // patientInfoY -= 10;
      // firstPage.drawLine({
      //   start: { x: patientInfoLeftX, y: patientInfoY },
      //   end: { x: patientInfoLeftX + 415, y: patientInfoY },
      //   thickness: 1,
      //   color: rgb(0.5, 0.5, 0.5),
      // });
      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (error) {
      console.log(error);
    } finally {
      setPressLoading(false);
    }
  };

  const [printing, setPriniting] = useState(false);
  const printDigitalPress = async (appointment) => {
    const appointment_id = appointment?._id;
    setPriniting(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/opd/prescription/${appointment_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const res = await response.json();

      let templateUrl;

      if (appointment?.doctorId?.whichAppointmentTemplate === "doctor") {
        templateUrl = appointment?.doctorId?.appointmentTemplate?.pdfUrl;
      } else {
        templateUrl = pdfTemplate;
      }

      await generatePrescriptionPDF(appointment, res?.data, templateUrl);
    } catch (error) {
      console.log(error);
    } finally {
      setPriniting(false);
    }
  };

  const generatePrescriptionPDF_claude = async (
    appointment,
    prescription,
    templateUrl,
  ) => {
    const existingPdfBytes = await fetch(templateUrl).then((res) =>
      res.arrayBuffer(),
    );

    const templatePdf = await PDFDocument.load(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    let page = pdfDoc.getPages()[0];

    /* ================= THEME ================= */
    const THEME_COLOR = rgb(0.58, 0.212, 0.204);
    const MUTED_COLOR = rgb(0.45, 0.45, 0.45);
    const LINE_COLOR = rgb(0.85, 0.85, 0.85);

    /* ================= CONTENT AREA (DYNAMIC) ================= */

    const pageHeight = page.getHeight();
    const template = appointment?.doctorId?.appointmentTemplate || {};

    const showVitals = template.showVitals === true;
    const prescriptionX = Number(template.prescriptionX || 30);
    const prescriptionY = Number(template.prescriptionY || 250);
    const prescriptionWidth = Number(template.prescriptionWidth || 530);
    const prescriptionHeight = Number(template.prescriptionHeight || 400);

    const CONTENT_START_X = prescriptionX;
    const CONTENT_START_Y = pageHeight - prescriptionY;
    const CONTENT_END_X = prescriptionX + prescriptionWidth;
    const CONTENT_END_Y = pageHeight - (prescriptionY + prescriptionHeight) + 8;
    const CONTENT_WIDTH = prescriptionWidth - 20;

    let y = CONTENT_START_Y - 10;
    let startX = CONTENT_START_X;

    /* ---------- PAGINATION ---------- */

    const newPage = async () => {
      const [copiedPage] = await pdfDoc.copyPages(templatePdf, [0]);
      pdfDoc.addPage(copiedPage);
      page = copiedPage;

      drawHeader();
      y = CONTENT_START_Y;
    };

    const ensureSpace = async (space = 80) => {
      if (y < CONTENT_END_Y) {
        await newPage();
      }
    };

    const drawDivider = () => {
      y -= 8;
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.6,
        color: LINE_COLOR,
      });
      y -= 14;
    };

    const drawThinDivider = () => {
      y -= 5;
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.4,
        color: LINE_COLOR,
      });
      y -= 9;
    };

    const wrapTextByWidth = (text, font, fontSize, maxWidth) => {
      const words = text.split(" ");
      const lines = [];
      let line = "";

      for (const word of words) {
        const testLine = line ? line + " " + word : word;
        const width = font.widthOfTextAtSize(testLine, fontSize);

        if (width < maxWidth) {
          line = testLine;
        } else {
          if (line) lines.push(line);
          line = word;
        }
      }

      if (line) lines.push(line);
      return lines;
    };

    const cleanList = (items) =>
      (items || []).filter(
        (i) => i !== null && i !== undefined && String(i).trim() !== "",
      );

    /* ================= SECTION HEADER (single column) ================= */
    const drawSectionHeader = (title, x = startX) => {
      page.drawText(title.toUpperCase(), {
        x,
        y,
        size: 11,
        font: boldFont,
        color: THEME_COLOR,
      });
      y -= 4;
      page.drawLine({
        start: { x, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.8,
        color: THEME_COLOR,
      });
      y -= 13;
    };

    /* ================= HEADER ================= */

    const drawHeader = () => {
      const pageHeight = page.getHeight();

      let doctorInfoX, doctorInfoY;
      let patientInfoLeftX, patientInfoLeftY;
      let patientInfoRightX, patientInfoRightY;
      let noteX, noteY;
      let fontSizeD = 16;

      if (
        appointment?.doctorId?.whichAppointmentTemplate === "org" ||
        appointment?.doctorId?.whichAppointmentTemplate === "doctor"
      ) {
        patientInfoLeftX = Number(
          appointment?.doctorId?.appointmentTemplate?.patientInfoLeftX,
        );
        patientInfoLeftY =
          pageHeight -
          Number(appointment?.doctorId?.appointmentTemplate?.patientInfoLeftY) -
          10;

        patientInfoRightX = Number(
          appointment?.doctorId?.appointmentTemplate?.patientInfoRightX,
        );
        patientInfoRightY =
          pageHeight -
          Number(
            appointment?.doctorId?.appointmentTemplate?.patientInfoRightY,
          ) -
          10;

        doctorInfoX = Number(
          appointment?.doctorId?.appointmentTemplate?.doctorX,
        );
        doctorInfoY =
          pageHeight -
          Number(appointment?.doctorId?.appointmentTemplate?.doctorY) -
          13;
      }

      if (appointment?.doctorId?.appointmentTemplate?.doctorInfo === "yes") {
        if (appointment?.doctorId?.name) {
          page.drawText(appointment.doctorId.name, {
            x: doctorInfoX,
            y: doctorInfoY,
            size: fontSizeD,
            font: boldFont,
            color: THEME_COLOR,
          });
          doctorInfoY -= 15;
        }

        (appointment?.doctorId?.qualifications || []).forEach((q) => {
          if (!q) return;
          page.drawText(q, {
            x: doctorInfoX,
            y: doctorInfoY,
            size: fontSizeD - 5,
            font: boldFont,
          });
          doctorInfoY -= 15;
        });
      }

      if (
        appointment?.doctorId?.appointmentTemplate?.doctorNote === "yes" &&
        appointment?.doctorId?.note
      ) {
        page.drawText(appointment.doctorId.note, {
          x: noteX,
          y: noteY,
          size: fontSizeD - 7,
          font: boldFont,
        });
      }

      if (
        appointment?.doctorId?.appointmentTemplate?.appNote === "yes" &&
        appointment?.note
      ) {
        page.drawText(appointment.note, {
          x: noteX,
          y: noteY - 15,
          size: fontSizeD - 7,
          font: boldFont,
        });
      }

      let fontSize = 11;

      page.drawText(appointment?.patientId?.name || "-", {
        x: patientInfoLeftX,
        y: patientInfoLeftY,
        size: fontSize + 1,
        font: boldFont,
      });

      if (appointment?.patientId?.patientID) {
        page.drawText("ID: " + appointment.patientId.patientID, {
          x: patientInfoRightX,
          y: patientInfoRightY,
          size: fontSize + 1,
          font: boldFont,
        });
      }

      patientInfoLeftY -= 15;
      patientInfoRightY -= 15;

      page.drawText(
        (appointment?.patientId?.gender || "-") +
          " / " +
          (calculateAge(appointment?.patientId?.dob) || "-"),
        { x: patientInfoLeftX, y: patientInfoLeftY, size: fontSize - 1, font },
      );

      if (appointment?.appDate) {
        page.drawText("Visit: " + formatDate(appointment.appDate), {
          x: patientInfoRightX,
          y: patientInfoRightY,
          size: fontSize - 1,
          font,
        });
      }

      patientInfoLeftY -= 15;
      patientInfoRightY -= 15;

      if (appointment?.patientId?.mobile) {
        page.drawText("Mob: " + appointment.patientId.mobile, {
          x: patientInfoLeftX,
          y: patientInfoLeftY,
          size: fontSize - 1,
          font,
        });
      }

      if (appointment?.appointmentId) {
        page.drawText("Appt ID: " + appointment.appointmentId, {
          x: patientInfoRightX,
          y: patientInfoRightY,
          size: fontSize - 1,
          font,
        });
      }
    };

    drawHeader();
    y = CONTENT_START_Y;

    const stripHtml = (html) => (html || "").replace(/<[^>]*>/g, "").trim();

    /* ================= VITALS — single compact line ================= */
    const drawVitalsLine = async () => {
      if (!showVitals) return;
      const v = prescription.vitals || {};
      const parts = [
        v.height ? `Height: ${v.height} cm` : null,
        v.weight ? `Weight: ${v.weight} kg` : null,
        v.pulse ? `Pulse: ${v.pulse} /min` : null,
        v.bp ? `BP: ${v.bp} mmHg` : null,
      ].filter(Boolean);
      if (parts.length === 0) return;

      await ensureSpace(20);
      page.drawText(parts.join("     |     "), {
        x: startX,
        y,
        size: 10.5,
        font,
        color: MUTED_COLOR,
      });
      y -= 10;
      drawThinDivider();
    };

    await drawVitalsLine();

    /* ================= NOTE — rich-text HTML rendered below vitals ================= */
    // The note comes from a Quill-style editor (bold/underline/alignment),
    // so it's rasterized with html2canvas rather than flattened to plain
    // text, then embedded as a PNG scaled to the content width. If the
    // rendered note is taller than the space left on the page, it's sliced
    // and continued on the next page — same approach as the report PDF
    // generator's HTML-to-PDF flow.
    const drawHtmlNote = async (html) => {
      if (!html || stripHtml(html) === "") return;

      const RENDER_WIDTH_PX = 900; // fixed off-screen render width for a stable scale factor

      const tempDiv = document.createElement("div");
      tempDiv.id = "prescription-note-render";
      tempDiv.style.position = "absolute";
      tempDiv.style.top = "-9999px";
      tempDiv.style.left = "-9999px";
      tempDiv.style.width = `${RENDER_WIDTH_PX}px`;
      tempDiv.style.margin = "0";
      tempDiv.style.padding = "0";
      tempDiv.style.paddingBottom = "10px";
      tempDiv.style.border = "none";
      tempDiv.style.boxSizing = "border-box";
      tempDiv.style.background = "transparent";

      // appendSanitizedReportHtml is expected to already exist in this app
      // (used for the report PDF flow) — falls back to innerHTML if not
      // available, but the sanitized path should be preferred wherever it exists.
      if (typeof appendSanitizedReportHtml === "function") {
        appendSanitizedReportHtml(tempDiv, html);
      } else {
        tempDiv.innerHTML = html;
      }

      const styleTag = document.createElement("style");
      styleTag.textContent = `
      #prescription-note-render {
        margin: 0;
        font-size: 18px !important;
        font-family: Arial, sans-serif;
        color: #1a1a1a;
        white-space: pre-wrap;
      }
      #prescription-note-render p, #prescription-note-render div {
        white-space: pre-wrap;
        margin: 0 0 4px 0;
        line-height: 20px;
      }
      #prescription-note-render .ql-align-center { text-align: center; }
      #prescription-note-render .ql-align-right { text-align: right; }
      #prescription-note-render .ql-align-left { text-align: left; }
      #prescription-note-render strong { font-weight: bold; }
      #prescription-note-render u { text-decoration: underline; }
    `;
      tempDiv.appendChild(styleTag);
      document.body.appendChild(tempDiv);

      const canvas = await html2canvas(tempDiv, {
        backgroundColor: null,
        scale: 3,
        scrollX: 0,
        scrollY: 0,
        useCORS: true,
      });

      document.body.removeChild(tempDiv);

      // Scale so the rasterized note's width matches the PDF content box exactly.
      const targetScale = CONTENT_WIDTH / canvas.width;
      const totalCanvasHeight = canvas.height;

      await ensureSpace(40);

      let startCanvasY = 0;

      while (startCanvasY < totalCanvasHeight) {
        const availableHeightPt = y - CONTENT_END_Y;
        const availableCanvasPx = Math.max(availableHeightPt / targetScale, 0);

        if (availableCanvasPx <= 0) {
          await newPage();
          continue;
        }

        const sliceCanvasHeight = Math.min(
          availableCanvasPx,
          totalCanvasHeight - startCanvasY,
        );

        const splitCanvas = document.createElement("canvas");
        splitCanvas.width = canvas.width;
        splitCanvas.height = sliceCanvasHeight;

        const splitCtx = splitCanvas.getContext("2d");
        splitCtx.drawImage(
          canvas,
          0,
          startCanvasY,
          canvas.width,
          sliceCanvasHeight,
          0,
          0,
          canvas.width,
          sliceCanvasHeight,
        );

        const splitImgData = splitCanvas.toDataURL("image/png");
        const splitPngImage = await pdfDoc.embedPng(splitImgData);
        const splitHeightPt = sliceCanvasHeight * targetScale;

        page.drawImage(splitPngImage, {
          x: startX,
          y: y - splitHeightPt,
          width: CONTENT_WIDTH,
          height: splitHeightPt,
        });

        y -= splitHeightPt;
        startCanvasY += sliceCanvasHeight;

        if (startCanvasY < totalCanvasHeight) {
          await newPage();
        }
      }

      drawThinDivider();
    };

    await drawHtmlNote(prescription.note);

    /* ================= TWO-COLUMN SECTION HELPER ================= */
    // Renders two lists side by side (e.g. Chief Complaints | Clinical
    // Findings, Advice | Investigations) with a divider between columns.
    // Skips columns/section entirely when empty — mirrors the source
    // prescription's side-by-side layout while staying compact.
    const drawTwoColumnSection = async (
      leftTitle,
      leftItems,
      rightTitle,
      rightItems,
    ) => {
      const leftClean = cleanList(leftItems);
      const rightClean = cleanList(rightItems);
      if (leftClean.length === 0 && rightClean.length === 0) return;

      const colGap = 24;
      const colWidth = (CONTENT_WIDTH - colGap) / 2;
      const leftX = startX;
      const rightX = startX + colWidth + colGap;

      const buildLines = (items) => {
        const lines = [];
        items.forEach((item) => {
          wrapTextByWidth(`\u2022  ${item}`, font, 10.5, colWidth - 8).forEach(
            (l) => lines.push(l),
          );
        });
        return lines;
      };

      const leftLines = buildLines(leftClean);
      const rightLines = buildLines(rightClean);
      const rowCount = Math.max(leftLines.length, rightLines.length);

      await ensureSpace(28 + rowCount * 13);

      if (leftClean.length) {
        page.drawText(leftTitle.toUpperCase(), {
          x: leftX,
          y,
          size: 10.5,
          font: boldFont,
          color: THEME_COLOR,
        });
      }
      if (rightClean.length) {
        page.drawText(rightTitle.toUpperCase(), {
          x: rightX,
          y,
          size: 10.5,
          font: boldFont,
          color: THEME_COLOR,
        });
      }
      y -= 4;
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.8,
        color: THEME_COLOR,
      });
      y -= 13;

      const colTopY = y + 13;

      for (let i = 0; i < rowCount; i++) {
        if (leftLines[i]) {
          page.drawText(leftLines[i], { x: leftX + 2, y, size: 10.5, font });
        }
        if (rightLines[i]) {
          page.drawText(rightLines[i], { x: rightX + 2, y, size: 10.5, font });
        }
        y -= 13;
      }

      // subtle vertical divider between the two columns (only when both used)
      if (leftClean.length && rightClean.length) {
        page.drawLine({
          start: { x: leftX + colWidth + colGap / 2, y: colTopY },
          end: { x: leftX + colWidth + colGap / 2, y: y + 13 },
          thickness: 0.5,
          color: LINE_COLOR,
        });
      }

      drawDivider();
    };

    /* ================= CHIEF COMPLAINTS | CLINICAL FINDINGS ================= */
    await drawTwoColumnSection(
      "Chief Complaints",
      prescription.symptoms,
      "Clinical Findings",
      prescription.diagnosis,
    );

    /* ================= MEDICINES — compact text table ================= */
    const drawMedicinesTable = async () => {
      const medicines = prescription.medicines || [];
      if (medicines.length === 0) return;

      await ensureSpace(60);
      drawSectionHeader("Medicines");

      const colName = startX;
      const colDosage = startX + CONTENT_WIDTH * 0.56;
      const colDuration = startX + CONTENT_WIDTH * 0.8;

      page.drawText("MEDICINE", {
        x: colName,
        y,
        size: 9,
        font: boldFont,
        color: MUTED_COLOR,
      });
      page.drawText("DOSAGE (M-A-E-N)", {
        x: colDosage,
        y,
        size: 9,
        font: boldFont,
        color: MUTED_COLOR,
      });
      page.drawText("DURATION", {
        x: colDuration,
        y,
        size: 9,
        font: boldFont,
        color: MUTED_COLOR,
      });
      y -= 5;
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.5,
        color: LINE_COLOR,
      });
      y -= 14;

      let index = 1;
      for (const med of medicines) {
        await ensureSpace(45);

        page.drawText(`${index}. ${med.medicine}`, {
          x: colName,
          y,
          size: 11,
          font: boldFont,
        });

        const dosage = [med.morning, med.afternoon, med.evening, med.night]
          .map((v) => v || "0")
          .join("-");
        page.drawText(dosage, { x: colDosage, y, size: 11, font });

        const duration = [med.duration, med.durationType]
          .filter(Boolean)
          .join(" ");
        page.drawText(duration || "-", { x: colDuration, y, size: 11, font });

        y -= 13;

        if (med.note) {
          const noteLines = wrapTextByWidth(
            med.note,
            font,
            9.5,
            CONTENT_WIDTH - 12,
          );
          for (const line of noteLines) {
            await ensureSpace();
            page.drawText(line, {
              x: colName + 12,
              y,
              size: 9.5,
              font,
              color: MUTED_COLOR,
            });
            y -= 11;
          }
        }

        page.drawLine({
          start: { x: startX, y: y + 4 },
          end: { x: CONTENT_END_X, y: y + 4 },
          thickness: 0.3,
          color: LINE_COLOR,
        });
        y -= 8;
        index++;
      }

      drawDivider();
    };

    await drawMedicinesTable();

    /* ================= ADVICE | INVESTIGATIONS ADVISED ================= */
    await drawTwoColumnSection(
      "Advice",
      prescription.advice,
      "Investigations Advised",
      (prescription.investigations || []).map((test) =>
        typeof test === "string"
          ? test
          : test?.isCustom
            ? test?.testName
            : test?.testId?.testName,
      ),
    );

    /* ================= FOLLOW-UP (next visit / referral) ================= */
    const followUpItems = [
      prescription.nextVisitDate
        ? `Next Visit: ${formatDate(prescription.nextVisitDate)}`
        : null,
      prescription.referredDoctor
        ? `Referred To: ${prescription.referredDoctor}`
        : null,
    ].filter(Boolean);

    if (followUpItems.length > 0) {
      await ensureSpace(20);
      page.drawText(followUpItems.join("     |     "), {
        x: startX,
        y,
        size: 10.5,
        font: boldFont,
        color: THEME_COLOR,
      });
      y -= 18;
    }

    /* ================= FOOTER ================= */

    if (prescription.createdAt) {
      page.drawText(
        `Generated: ${new Date(prescription.createdAt).toLocaleString()}`,
        { x: startX, y: 30, size: 9, font, color: MUTED_COLOR },
      );
    }

    /* ================= SAVE ================= */

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url);
  };

  // Add these to your existing imports at the top of the file that contains
  // generatePrescriptionPDF. Adjust the second path to wherever
  // appendSanitizedReportHtml actually lives in your project (it's the same
  // helper your report-PDF flow already uses).

  const generatePrescriptionPDF = async (
    appointment,
    prescription,
    templateUrl,
  ) => {
    const existingPdfBytes = await fetch(templateUrl).then((res) =>
      res.arrayBuffer(),
    );

    const templatePdf = await PDFDocument.load(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    let page = pdfDoc.getPages()[0];

    /* ================= THEME ================= */
    const THEME_COLOR = rgb(0.58, 0.212, 0.204);
    const MUTED_COLOR = rgb(0.45, 0.45, 0.45);
    const LINE_COLOR = rgb(0.85, 0.85, 0.85);

    /* ================= CONTENT AREA (DYNAMIC) ================= */

    const pageHeight = page.getHeight();
    const template = appointment?.doctorId?.appointmentTemplate || {};

    const showVitals = template.showVitals === true;
    const prescriptionX = Number(template.prescriptionX || 30);
    const prescriptionY = Number(template.prescriptionY || 250);
    const prescriptionWidth = Number(template.prescriptionWidth || 530);
    const prescriptionHeight = Number(template.prescriptionHeight || 400);

    const CONTENT_START_X = prescriptionX;
    const CONTENT_START_Y = pageHeight - prescriptionY;
    const CONTENT_END_X = prescriptionX + prescriptionWidth;
    const CONTENT_END_Y = pageHeight - (prescriptionY + prescriptionHeight) + 8;
    const CONTENT_WIDTH = prescriptionWidth - 20;

    let y = CONTENT_START_Y - 10;
    let startX = CONTENT_START_X;

    /* ---------- PAGINATION ---------- */

    const newPage = async () => {
      const [copiedPage] = await pdfDoc.copyPages(templatePdf, [0]);
      pdfDoc.addPage(copiedPage);
      page = copiedPage;

      drawHeader();
      y = CONTENT_START_Y;
    };

    const ensureSpace = async (space = 80) => {
      if (y < CONTENT_END_Y) {
        await newPage();
      }
    };

    const drawDivider = () => {
      y -= 8;
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.6,
        color: LINE_COLOR,
      });
      y -= 14;
    };

    const drawThinDivider = () => {
      y -= 5;
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.4,
        color: LINE_COLOR,
      });
      y -= 9;
    };

    const wrapTextByWidth = (text, font, fontSize, maxWidth) => {
      const words = text.split(" ");
      const lines = [];
      let line = "";

      for (const word of words) {
        const testLine = line ? line + " " + word : word;
        const width = font.widthOfTextAtSize(testLine, fontSize);

        if (width < maxWidth) {
          line = testLine;
        } else {
          if (line) lines.push(line);
          line = word;
        }
      }

      if (line) lines.push(line);
      return lines;
    };

    const cleanList = (items) =>
      (items || []).filter(
        (i) => i !== null && i !== undefined && String(i).trim() !== "",
      );

    /* ================= SECTION HEADER (single column) ================= */
    const drawSectionHeader = (title, x = startX) => {
      page.drawText(title.toUpperCase(), {
        x,
        y,
        size: 11,
        font: boldFont,
        color: THEME_COLOR,
      });
      y -= 4;
      page.drawLine({
        start: { x, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.8,
        color: THEME_COLOR,
      });
      y -= 13;
    };

    /* ================= HEADER ================= */

    const drawHeader = () => {
      const pageHeight = page.getHeight();

      let doctorInfoX, doctorInfoY;
      let patientInfoLeftX, patientInfoLeftY;
      let patientInfoRightX, patientInfoRightY;
      let noteX, noteY;
      let fontSizeD = 16;

      if (
        appointment?.doctorId?.whichAppointmentTemplate === "org" ||
        appointment?.doctorId?.whichAppointmentTemplate === "doctor"
      ) {
        patientInfoLeftX = Number(
          appointment?.doctorId?.appointmentTemplate?.patientInfoLeftX,
        );
        patientInfoLeftY =
          pageHeight -
          Number(appointment?.doctorId?.appointmentTemplate?.patientInfoLeftY) -
          10;

        patientInfoRightX = Number(
          appointment?.doctorId?.appointmentTemplate?.patientInfoRightX,
        );
        patientInfoRightY =
          pageHeight -
          Number(
            appointment?.doctorId?.appointmentTemplate?.patientInfoRightY,
          ) -
          10;

        doctorInfoX = Number(
          appointment?.doctorId?.appointmentTemplate?.doctorX,
        );
        doctorInfoY =
          pageHeight -
          Number(appointment?.doctorId?.appointmentTemplate?.doctorY) -
          13;
      }

      if (appointment?.doctorId?.appointmentTemplate?.doctorInfo === "yes") {
        if (appointment?.doctorId?.name) {
          page.drawText(appointment.doctorId.name, {
            x: doctorInfoX,
            y: doctorInfoY,
            size: fontSizeD,
            font: boldFont,
            color: THEME_COLOR,
          });
          doctorInfoY -= 15;
        }

        (appointment?.doctorId?.qualifications || []).forEach((q) => {
          if (!q) return;
          page.drawText(q, {
            x: doctorInfoX,
            y: doctorInfoY,
            size: fontSizeD - 5,
            font: boldFont,
          });
          doctorInfoY -= 15;
        });
      }

      if (
        appointment?.doctorId?.appointmentTemplate?.doctorNote === "yes" &&
        appointment?.doctorId?.note
      ) {
        page.drawText(appointment.doctorId.note, {
          x: noteX,
          y: noteY,
          size: fontSizeD - 7,
          font: boldFont,
        });
      }

      if (
        appointment?.doctorId?.appointmentTemplate?.appNote === "yes" &&
        appointment?.note
      ) {
        page.drawText(appointment.note, {
          x: noteX,
          y: noteY - 15,
          size: fontSizeD - 7,
          font: boldFont,
        });
      }

      let fontSize = 11;

      page.drawText(appointment?.patientId?.name || "-", {
        x: patientInfoLeftX,
        y: patientInfoLeftY,
        size: fontSize + 1,
        font: boldFont,
      });

      if (appointment?.patientId?.patientID) {
        page.drawText("ID: " + appointment.patientId.patientID, {
          x: patientInfoRightX,
          y: patientInfoRightY,
          size: fontSize + 1,
          font: boldFont,
        });
      }

      patientInfoLeftY -= 15;
      patientInfoRightY -= 15;

      page.drawText(
        (appointment?.patientId?.gender || "-") +
          " / " +
          (calculateAge(appointment?.patientId?.dob) || "-"),
        { x: patientInfoLeftX, y: patientInfoLeftY, size: fontSize - 1, font },
      );

      if (appointment?.appDate) {
        page.drawText("Visit: " + formatDate(appointment.appDate), {
          x: patientInfoRightX,
          y: patientInfoRightY,
          size: fontSize - 1,
          font,
        });
      }

      patientInfoLeftY -= 15;
      patientInfoRightY -= 15;

      if (appointment?.patientId?.mobile) {
        page.drawText("Mob: " + appointment.patientId.mobile, {
          x: patientInfoLeftX,
          y: patientInfoLeftY,
          size: fontSize - 1,
          font,
        });
      }

      if (appointment?.appointmentId) {
        page.drawText("Appt ID: " + appointment.appointmentId, {
          x: patientInfoRightX,
          y: patientInfoRightY,
          size: fontSize - 1,
          font,
        });
      }
    };

    drawHeader();
    y = CONTENT_START_Y;

    const stripHtml = (html) => (html || "").replace(/<[^>]*>/g, "").trim();

    /* ================= VITALS — single compact line ================= */
    const drawVitalsLine = async () => {
      if (!showVitals) return;
      const v = prescription.vitals || {};
      const parts = [
        v.height ? `Height: ${v.height} cm` : null,
        v.weight ? `Weight: ${v.weight} kg` : null,
        v.pulse ? `Pulse: ${v.pulse} /min` : null,
        v.bp ? `BP: ${v.bp} mmHg` : null,
      ].filter(Boolean);
      if (parts.length === 0) return;

      await ensureSpace(20);
      page.drawText(parts.join("     |     "), {
        x: startX,
        y,
        size: 10.5,
        font,
        color: MUTED_COLOR,
      });
      y -= 10;
      drawThinDivider();
    };

    await drawVitalsLine();

    /* ================= NOTE — rich-text HTML rendered below vitals ================= */
    // The note comes from a Quill-style editor (bold/underline/alignment),
    // so it's rasterized with html2canvas rather than flattened to plain
    // text, then embedded as a PNG scaled to the content width. If the
    // rendered note is taller than the space left on the page, it's sliced
    // and continued on the next page — same approach as the report PDF
    // generator's HTML-to-PDF flow.
    const drawHtmlNote = async (html) => {
      if (!html || stripHtml(html) === "") return;

      const RENDER_WIDTH_PX = 900; // fixed off-screen render width for a stable scale factor

      const tempDiv = document.createElement("div");
      tempDiv.id = "prescription-note-render";
      tempDiv.style.position = "absolute";
      tempDiv.style.top = "-9999px";
      tempDiv.style.left = "-9999px";
      tempDiv.style.width = `${RENDER_WIDTH_PX}px`;
      tempDiv.style.margin = "0";
      tempDiv.style.padding = "0";
      tempDiv.style.paddingBottom = "10px";
      tempDiv.style.border = "none";
      tempDiv.style.boxSizing = "border-box";
      tempDiv.style.background = "transparent";

      // appendSanitizedReportHtml is expected to already exist in this app
      // (used for the report PDF flow) — falls back to innerHTML if not
      // available, but the sanitized path should be preferred wherever it exists.
      if (typeof appendSanitizedReportHtml === "function") {
        appendSanitizedReportHtml(tempDiv, html);
      } else {
        tempDiv.innerHTML = html;
      }

      const styleTag = document.createElement("style");
      styleTag.textContent = `
      #prescription-note-render {
        margin: 0;
        font-size: 18px !important;
        font-family: Arial, sans-serif;
        color: #1a1a1a;
        white-space: pre-wrap;
      }
      #prescription-note-render p, #prescription-note-render div {
        white-space: pre-wrap;
        margin: 0 0 4px 0;
        line-height: 20px;
      }
      #prescription-note-render .ql-align-center { text-align: center; }
      #prescription-note-render .ql-align-right { text-align: right; }
      #prescription-note-render .ql-align-left { text-align: left; }
      #prescription-note-render strong { font-weight: bold; }
      #prescription-note-render u { text-decoration: underline; }
    `;
      tempDiv.appendChild(styleTag);
      document.body.appendChild(tempDiv);

      const canvas = await html2canvas(tempDiv, {
        backgroundColor: null,
        scale: 3,
        scrollX: 0,
        scrollY: 0,
        useCORS: true,
      });

      document.body.removeChild(tempDiv);

      // Scale so the rasterized note's width matches the PDF content box exactly.
      const targetScale = CONTENT_WIDTH / canvas.width;
      const totalCanvasHeight = canvas.height;

      await ensureSpace(60);
      drawSectionHeader("Note");
      y += 8; // pull the note image closer to the header underline than the default section gap

      let startCanvasY = 0;

      while (startCanvasY < totalCanvasHeight) {
        const availableHeightPt = y - CONTENT_END_Y;
        const availableCanvasPx = Math.max(availableHeightPt / targetScale, 0);

        if (availableCanvasPx <= 0) {
          await newPage();
          continue;
        }

        const sliceCanvasHeight = Math.min(
          availableCanvasPx,
          totalCanvasHeight - startCanvasY,
        );

        const splitCanvas = document.createElement("canvas");
        splitCanvas.width = canvas.width;
        splitCanvas.height = sliceCanvasHeight;

        const splitCtx = splitCanvas.getContext("2d");
        splitCtx.drawImage(
          canvas,
          0,
          startCanvasY,
          canvas.width,
          sliceCanvasHeight,
          0,
          0,
          canvas.width,
          sliceCanvasHeight,
        );

        const splitImgData = splitCanvas.toDataURL("image/png");
        const splitPngImage = await pdfDoc.embedPng(splitImgData);
        const splitHeightPt = sliceCanvasHeight * targetScale;

        page.drawImage(splitPngImage, {
          x: startX,
          y: y - splitHeightPt,
          width: CONTENT_WIDTH,
          height: splitHeightPt,
        });

        y -= splitHeightPt;
        startCanvasY += sliceCanvasHeight;

        if (startCanvasY < totalCanvasHeight) {
          await newPage();
        }
      }

      drawThinDivider();
    };

    await drawHtmlNote(prescription.note);

    /* ================= TWO-COLUMN SECTION HELPER ================= */
    // Renders two lists side by side (e.g. Chief Complaints | Clinical
    // Findings, Advice | Investigations) with a divider between columns.
    // Skips columns/section entirely when empty — mirrors the source
    // prescription's side-by-side layout while staying compact.
    const drawTwoColumnSection = async (
      leftTitle,
      leftItems,
      rightTitle,
      rightItems,
    ) => {
      const leftClean = cleanList(leftItems);
      const rightClean = cleanList(rightItems);
      if (leftClean.length === 0 && rightClean.length === 0) return;

      const colGap = 24;
      const colWidth = (CONTENT_WIDTH - colGap) / 2;
      const leftX = startX;
      const rightX = startX + colWidth + colGap;

      const buildLines = (items) => {
        const lines = [];
        items.forEach((item) => {
          wrapTextByWidth(`\u2022  ${item}`, font, 10.5, colWidth - 8).forEach(
            (l) => lines.push(l),
          );
        });
        return lines;
      };

      const leftLines = buildLines(leftClean);
      const rightLines = buildLines(rightClean);
      const rowCount = Math.max(leftLines.length, rightLines.length);

      await ensureSpace(28 + rowCount * 13);

      if (leftClean.length) {
        page.drawText(leftTitle.toUpperCase(), {
          x: leftX,
          y,
          size: 10.5,
          font: boldFont,
          color: THEME_COLOR,
        });
      }
      if (rightClean.length) {
        page.drawText(rightTitle.toUpperCase(), {
          x: rightX,
          y,
          size: 10.5,
          font: boldFont,
          color: THEME_COLOR,
        });
      }
      y -= 4;
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.8,
        color: THEME_COLOR,
      });
      y -= 13;

      const colTopY = y + 13;

      for (let i = 0; i < rowCount; i++) {
        if (leftLines[i]) {
          page.drawText(leftLines[i], { x: leftX + 2, y, size: 10.5, font });
        }
        if (rightLines[i]) {
          page.drawText(rightLines[i], { x: rightX + 2, y, size: 10.5, font });
        }
        y -= 13;
      }

      // subtle vertical divider between the two columns (only when both used)
      if (leftClean.length && rightClean.length) {
        page.drawLine({
          start: { x: leftX + colWidth + colGap / 2, y: colTopY },
          end: { x: leftX + colWidth + colGap / 2, y: y + 13 },
          thickness: 0.5,
          color: LINE_COLOR,
        });
      }

      drawDivider();
    };

    /* ================= CHIEF COMPLAINTS | CLINICAL FINDINGS ================= */
    await drawTwoColumnSection(
      "Chief Complaints",
      prescription.symptoms,
      "Clinical Findings",
      prescription.diagnosis,
    );

    /* ================= MEDICINES — compact text table ================= */
    const drawMedicinesTable = async () => {
      const medicines = prescription.medicines || [];
      if (medicines.length === 0) return;

      await ensureSpace(60);
      drawSectionHeader("Medicines");

      const colName = startX;
      const colDosage = startX + CONTENT_WIDTH * 0.56;
      const colDuration = startX + CONTENT_WIDTH * 0.8;

      page.drawText("MEDICINE", {
        x: colName,
        y,
        size: 9,
        font: boldFont,
        color: MUTED_COLOR,
      });
      page.drawText("DOSAGE (M-A-E-N)", {
        x: colDosage,
        y,
        size: 9,
        font: boldFont,
        color: MUTED_COLOR,
      });
      page.drawText("DURATION", {
        x: colDuration,
        y,
        size: 9,
        font: boldFont,
        color: MUTED_COLOR,
      });
      y -= 5;
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.5,
        color: LINE_COLOR,
      });
      y -= 14;

      let index = 1;
      for (const med of medicines) {
        await ensureSpace(45);

        page.drawText(`${index}. ${med.medicine}`, {
          x: colName,
          y,
          size: 11,
          font: boldFont,
        });

        const dosage = [med.morning, med.afternoon, med.evening, med.night]
          .map((v) => v || "0")
          .join("-");
        page.drawText(dosage, { x: colDosage, y, size: 11, font });

        const duration = [med.duration, med.durationType]
          .filter(Boolean)
          .join(" ");
        page.drawText(duration || "-", { x: colDuration, y, size: 11, font });

        y -= 13;

        if (med.note) {
          const noteLines = wrapTextByWidth(
            med.note,
            font,
            9.5,
            CONTENT_WIDTH - 12,
          );
          for (const line of noteLines) {
            await ensureSpace();
            page.drawText(line, {
              x: colName + 12,
              y,
              size: 9.5,
              font,
              color: MUTED_COLOR,
            });
            y -= 11;
          }
        }

        page.drawLine({
          start: { x: startX, y: y + 4 },
          end: { x: CONTENT_END_X, y: y + 4 },
          thickness: 0.3,
          color: LINE_COLOR,
        });
        y -= 8;
        index++;
      }

      drawDivider();
    };

    await drawMedicinesTable();

    /* ================= ADVICE | INVESTIGATIONS ADVISED ================= */
    await drawTwoColumnSection(
      "Advice",
      prescription.advice,
      "Investigations Advised",
      (prescription.investigations || []).map((test) =>
        typeof test === "string"
          ? test
          : test?.isCustom
            ? test?.testName
            : test?.testId?.testName,
      ),
    );

    /* ================= FOLLOW-UP (next visit / referral) ================= */
    const followUpItems = [
      prescription.nextVisitDate
        ? `Next Visit: ${formatDate(prescription.nextVisitDate)}`
        : null,
      prescription.referredDoctor
        ? `Referred To: ${prescription.referredDoctor}`
        : null,
    ].filter(Boolean);

    if (followUpItems.length > 0) {
      await ensureSpace(20);
      page.drawText(followUpItems.join("     |     "), {
        x: startX,
        y,
        size: 10.5,
        font: boldFont,
        color: THEME_COLOR,
      });
      y -= 18;
    }

    /* ================= FOOTER ================= */

    if (prescription.createdAt) {
      page.drawText(
        `Generated: ${new Date(prescription.createdAt).toLocaleString()}`,
        { x: startX, y: 30, size: 9, font, color: MUTED_COLOR },
      );
    }

    /* ================= SAVE ================= */

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url);
  };

  const generatePrescriptionPDF1 = async (
    appointment,
    prescription,
    templateUrl,
  ) => {
    const existingPdfBytes = await fetch(templateUrl).then((res) =>
      res.arrayBuffer(),
    );

    // template used only for cloning pages
    const templatePdf = await PDFDocument.load(existingPdfBytes);

    // working pdf
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    let page = pdfDoc.getPages()[0];

    /* ================= CONTENT AREA (DYNAMIC) ================= */

    const pageHeight = page.getHeight();

    const template = appointment?.doctorId?.appointmentTemplate || {};
    console.log("template ", template);

    /* Convert string values to numbers safely */
    const showVitals = template.showVitals === true ? true : false;
    const prescriptionX = Number(template.prescriptionX || 30);
    const prescriptionY = Number(template.prescriptionY || 250);
    const prescriptionWidth = Number(template.prescriptionWidth || 530);
    const prescriptionHeight = Number(template.prescriptionHeight || 400);

    /* Because PDF origin is bottom-left */
    const CONTENT_START_X = prescriptionX;
    const CONTENT_START_Y = pageHeight - prescriptionY;
    const CONTENT_END_X = prescriptionX + prescriptionWidth;
    // const CONTENT_END_Y = CONTENT_START_Y - prescriptionHeight;
    const CONTENT_END_Y = pageHeight - (prescriptionY + prescriptionHeight) + 8;
    const CONTENT_WIDTH = prescriptionWidth - 20;

    /* Initial cursor */
    let y = CONTENT_START_Y - 10;
    let startX = CONTENT_START_X;

    /* ---------- PAGINATION ---------- */

    const newPage = async () => {
      const [copiedPage] = await pdfDoc.copyPages(templatePdf, [0]);
      pdfDoc.addPage(copiedPage);
      page = copiedPage;

      drawHeader();
      y = CONTENT_START_Y;
    };

    const ensureSpace = async (space = 80) => {
      if (y < CONTENT_END_Y) {
        await newPage();
      }
    };

    const drawDivider = () => {
      y -= 10;
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.6,
        color: rgb(0.85, 0.85, 0.85),
      });
      y -= 18;
    };

    // const wrapText = (text, maxChars = 85) => {
    //   const words = text.split(" ");
    //   let lines = [];
    //   let line = "";

    //   words.forEach((word) => {
    //     if ((line + word).length > maxChars) {
    //       lines.push(line);
    //       line = word + " ";
    //     } else {
    //       line += word + " ";
    //     }
    //   });

    //   lines.push(line);
    //   return lines;
    // };
    const wrapTextByWidth = (text, font, fontSize, maxWidth) => {
      const words = text.split(" ");
      const lines = [];
      let line = "";

      for (const word of words) {
        const testLine = line ? line + " " + word : word;
        const width = font.widthOfTextAtSize(testLine, fontSize);

        if (width < maxWidth) {
          line = testLine;
        } else {
          if (line) lines.push(line);
          line = word;
        }
      }

      if (line) lines.push(line);

      return lines;
    };

    /* ================= HEADER ================= */

    const drawHeader = () => {
      const pageHeight = page.getHeight();

      let doctorInfoX, doctorInfoY;
      let patientInfoLeftX, patientInfoLeftY;
      let patientInfoRightX, patientInfoRightY;

      let noteX, noteY;

      let fontSizeD = 16;

      if (
        appointment?.doctorId?.whichAppointmentTemplate === "org" ||
        appointment?.doctorId?.whichAppointmentTemplate === "doctor"
      ) {
        patientInfoLeftX = Number(
          appointment?.doctorId?.appointmentTemplate?.patientInfoLeftX,
        );
        patientInfoLeftY =
          pageHeight -
          Number(appointment?.doctorId?.appointmentTemplate?.patientInfoLeftY) -
          10;

        patientInfoRightX = Number(
          appointment?.doctorId?.appointmentTemplate?.patientInfoRightX,
        );
        patientInfoRightY =
          pageHeight -
          Number(
            appointment?.doctorId?.appointmentTemplate?.patientInfoRightY,
          ) -
          10;

        doctorInfoX = Number(
          appointment?.doctorId?.appointmentTemplate?.doctorX,
        );
        doctorInfoY =
          pageHeight -
          Number(appointment?.doctorId?.appointmentTemplate?.doctorY) -
          13;
      }

      /* Doctor Info */

      if (appointment?.doctorId?.appointmentTemplate?.doctorInfo === "yes") {
        page.drawText(appointment?.doctorId?.name || "", {
          x: doctorInfoX,
          y: doctorInfoY,
          size: fontSizeD,
          font: boldFont,
          color: rgb(0.58, 0.212, 0.204),
        });

        doctorInfoY -= 15;

        appointment?.doctorId?.qualifications?.forEach((q) => {
          page.drawText(q, {
            x: doctorInfoX,
            y: doctorInfoY,
            size: fontSizeD - 5,
            font: boldFont,
          });
          doctorInfoY -= 15;
        });
      }

      /* Notes */

      if (appointment?.doctorId?.appointmentTemplate?.doctorNote === "yes") {
        if (appointment?.doctorId?.note) {
          page.drawText(appointment?.doctorId?.note, {
            x: noteX,
            y: noteY,
            size: fontSizeD - 7,
            font: boldFont,
          });
        }
      }

      if (appointment?.doctorId?.appointmentTemplate?.appNote === "yes") {
        if (appointment?.note) {
          page.drawText(appointment?.note, {
            x: noteX,
            y: noteY - 15,
            size: fontSizeD - 7,
            font: boldFont,
          });
        }
      }

      let fontSize = 11;

      console.log("appointment", appointment);
      page.drawText(appointment?.patientId?.name || "-", {
        x: patientInfoLeftX,
        y: patientInfoLeftY,
        size: fontSize + 1,
        font: boldFont,
      });

      page.drawText("UHID: " + (appointment?.patientId?.patientID || "-"), {
        x: patientInfoRightX,
        y: patientInfoRightY,
        size: fontSize + 1,
        font: boldFont,
      });

      patientInfoLeftY -= 15;
      patientInfoRightY -= 15;

      page.drawText(
        "Sex/Age: " +
          appointment?.patientId?.gender +
          " / " +
          calculateAge(appointment?.patientId?.dob),
        { x: patientInfoLeftX, y: patientInfoLeftY, size: fontSize - 1, font },
      );

      page.drawText("Appointment ID: " + appointment?.appointmentId, {
        x: patientInfoRightX,
        y: patientInfoRightY,
        size: fontSize - 1,
        font,
      });

      patientInfoLeftY -= 15;
      patientInfoRightY -= 15;

      page.drawText("Mobile: " + appointment?.patientId?.mobile, {
        x: patientInfoLeftX,
        y: patientInfoLeftY,
        size: fontSize - 1,
        font,
      });

      page.drawText("Appointment Date: " + formatDate(appointment?.appDate), {
        x: patientInfoRightX,
        y: patientInfoRightY,
        size: fontSize - 1,
        font,
      });
    };

    drawHeader();
    y = CONTENT_START_Y;

    /* ================= VITALS ================= */

    if (showVitals) {
      page.drawText("Vitals", { x: startX, y, size: 13, font: boldFont });
      y -= 18;

      const vitals = prescription.vitals || {};

      page.drawText(`Height: ${vitals.height || "-"}`, {
        x: startX,
        y,
        size: 11,
        font,
      });
      page.drawText(`Weight: ${vitals.weight || "-"}`, {
        x: startX + 130,
        y,
        size: 11,
        font,
      });
      page.drawText(`Pulse: ${vitals.pulse || "-"}`, {
        x: startX + 260,
        y,
        size: 11,
        font,
      });
      page.drawText(`BP: ${vitals.bp || "-"}`, {
        x: startX + 390,
        y,
        size: 11,
        font,
      });

      drawDivider();
    }

    /* ================= MEDICAL HISTORY ================= */

    // page.drawText("Medical History", {
    //   x: startX,
    //   y,
    //   size: 13,
    //   font: boldFont,
    // });
    // y -= 16;

    // for (const s of prescription.symptoms || []) {
    //   await ensureSpace();
    //   page.drawText(`• ${s}`, { x: startX + 10, y, size: 11, font });
    //   y -= 14;
    // }
    page.drawText("Medical History", {
      x: startX,
      y,
      size: 13,
      font: boldFont,
    });
    y -= 16;

    const historyText = (prescription.symptoms || [])
      .map((s, i) => `${s}`)
      .join(", ");

    const historyLines = wrapTextByWidth(historyText, font, 11, CONTENT_WIDTH);

    for (const line of historyLines) {
      await ensureSpace();
      page.drawText(line, {
        x: startX + 10,
        y,
        size: 11,
        font,
      });
      y -= 14;
    }

    drawDivider();

    /* ================= INVESTIGATIONS ================= */

    // page.drawText("Investigations Needed", {
    //   x: startX,
    //   y,
    //   size: 13,
    //   font: boldFont,
    // });
    // y -= 16;

    // for (const test of prescription.investigations || []) {
    //   await ensureSpace();
    //   const name = test.isCustom ? test.testName : test.testId?.testName;
    //   page.drawText(`• ${name}`, { x: startX + 10, y, size: 11, font });
    //   y -= 14;
    // }
    page.drawText("Investigations Needed", {
      x: startX,
      y,
      size: 13,
      font: boldFont,
    });
    y -= 16;

    const investigationText = (prescription.investigations || [])
      .map((test, i) => {
        const name = test.isCustom ? test.testName : test.testId?.testName;
        return `${name}`;
      })
      .join(", ");
    const wrapText = (text, maxChars = 85) => {
      const words = text.split(" ");
      let lines = [];
      let line = "";
      words.forEach((word) => {
        if ((line + word).length > maxChars) {
          lines.push(line);
          line = word + " ";
        } else {
          line += word + " ";
        }
      });
      lines.push(line);
      return lines;
    };

    const investigationLines = wrapTextByWidth(
      investigationText,
      font,
      11,
      CONTENT_WIDTH,
    );

    for (const line of investigationLines) {
      await ensureSpace();
      page.drawText(line, {
        x: startX + 10,
        y,
        size: 11,
        font,
      });
      y -= 14;
    }

    drawDivider();

    /* ================= MEDICINES ================= */
    // load icons
    const morningBytes = await fetch(morningImg).then((res) =>
      res.arrayBuffer(),
    );
    const afternoonBytes = await fetch(afternoonImg).then((res) =>
      res.arrayBuffer(),
    );
    const eveningBytes = await fetch(eveningImg).then((res) =>
      res.arrayBuffer(),
    );
    const nightBytes = await fetch(nightImg).then((res) => res.arrayBuffer());

    // embed into pdf
    const morningIcon = await pdfDoc.embedPng(morningBytes);
    const afternoonIcon = await pdfDoc.embedPng(afternoonBytes);
    const eveningIcon = await pdfDoc.embedPng(eveningBytes);
    const nightIcon = await pdfDoc.embedPng(nightBytes);

    /* ================= MEDICINES ================= */

    const colMedicine = startX;
    const colMorning = CONTENT_END_X - 260;
    const colAfternoon = CONTENT_END_X - 200;
    const colEvening = CONTENT_END_X - 140;
    const colNight = CONTENT_END_X - 80;

    page.drawText("MEDICINES", {
      x: startX,
      y: y - 9,
      size: 13,
      font: boldFont,
    });
    // y -= 18;

    /* -------- ICON HEADER -------- */

    const iconSize = 20;
    const labelOffset = 14;

    page.drawImage(morningIcon, {
      x: colMorning - 5,
      y: y - 5,
      width: iconSize,
      height: iconSize,
    });

    page.drawImage(afternoonIcon, {
      x: colAfternoon - 5,
      y: y - 5,
      width: iconSize,
      height: iconSize,
    });

    page.drawImage(eveningIcon, {
      x: colEvening - 5,
      y: y - 5,
      width: iconSize,
      height: iconSize,
    });

    page.drawImage(nightIcon, {
      x: colNight - 5,
      y: y - 5,
      width: iconSize,
      height: iconSize,
    });

    /* labels under icons */

    page.drawText("Morning", {
      x: colMorning - 8,
      y: y - labelOffset,
      size: 8,
      font,
    });

    page.drawText("Afternoon", {
      x: colAfternoon - 10,
      y: y - labelOffset,
      size: 8,
      font,
    });

    page.drawText("Evening", {
      x: colEvening - 8,
      y: y - labelOffset,
      size: 8,
      font,
    });

    page.drawText("Night", {
      x: colNight - 4,
      y: y - labelOffset,
      size: 8,
      font,
    });

    y -= 26;

    page.drawLine({
      start: { x: startX, y },
      end: { x: CONTENT_END_X, y },
      thickness: 0.8,
    });

    y -= 16;

    /* -------- MEDICINE ROWS -------- */

    let index = 1;

    for (const med of prescription.medicines || []) {
      await ensureSpace(120);

      /* medicine name */
      page.drawText(`${index}. ${med.medicine}`, {
        x: colMedicine,
        y,
        size: 11,
        font: boldFont,
      });

      /* dosage timing */
      page.drawText(med.morning || "-", { x: colMorning, y, size: 11, font });
      page.drawText(med.afternoon || "-", {
        x: colAfternoon,
        y,
        size: 11,
        font,
      });
      page.drawText(med.evening || "-", { x: colEvening, y, size: 11, font });
      page.drawText(med.night || "-", { x: colNight, y, size: 11, font });

      y -= 14;

      /* duration + note inline */
      const durationText = `${med.duration || ""} ${med.durationType || ""}`;
      const noteText = med.note ? ` | ${med.note}` : "";

      const fullLine = durationText + noteText;

      const availableWidth = CONTENT_END_X - (colMedicine + 15);

      const wrappedLines = wrapTextByWidth(fullLine, font, 10, availableWidth);

      for (const line of wrappedLines) {
        await ensureSpace();

        page.drawText(line, {
          x: colMedicine + 15,
          y,
          size: 10,
          font,
          color: rgb(0.35, 0.35, 0.35),
        });

        y -= 12;
      }

      /* divider */
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.4,
        color: rgb(0.85, 0.85, 0.85),
      });

      y -= 14;

      index++;
    }

    /* ================= FOOTER ================= */

    page.drawText(
      `Generated: ${new Date(prescription.createdAt).toLocaleString()}`,
      { x: startX, y: 30, size: 9, font, color: rgb(0.5, 0.5, 0.5) },
    );

    /* ================= SAVE ================= */

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url);
  };

  const generatePrescriptionPDFBACKUP = async (
    appointment,
    prescription,
    templateUrl,
  ) => {
    const existingPdfBytes = await fetch(templateUrl).then((res) =>
      res.arrayBuffer(),
    );

    // template used only for cloning pages
    const templatePdf = await PDFDocument.load(existingPdfBytes);

    // working pdf
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    let page = pdfDoc.getPages()[0];

    /* ================= CONTENT AREA ================= */

    const CONTENT_START_X = 30;
    const CONTENT_START_Y = page.getHeight() - 300;
    const CONTENT_END_X = 565;
    const CONTENT_END_Y = 60;
    const CONTENT_WIDTH = CONTENT_END_X - CONTENT_START_X - 20;

    let y = CONTENT_START_Y;
    let startX = CONTENT_START_X;

    /* ---------- PAGINATION ---------- */

    const newPage = async () => {
      const [copiedPage] = await pdfDoc.copyPages(templatePdf, [0]);
      pdfDoc.addPage(copiedPage);
      page = copiedPage;

      drawHeader();
      y = CONTENT_START_Y;
    };

    const ensureSpace = async (space = 80) => {
      if (y < CONTENT_END_Y + space) {
        await newPage();
      }
    };

    const drawDivider = () => {
      y -= 10;
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.6,
        color: rgb(0.85, 0.85, 0.85),
      });
      y -= 18;
    };

    // const wrapText = (text, maxChars = 85) => {
    //   const words = text.split(" ");
    //   let lines = [];
    //   let line = "";

    //   words.forEach((word) => {
    //     if ((line + word).length > maxChars) {
    //       lines.push(line);
    //       line = word + " ";
    //     } else {
    //       line += word + " ";
    //     }
    //   });

    //   lines.push(line);
    //   return lines;
    // };
    const wrapTextByWidth = (text, font, fontSize, maxWidth) => {
      const words = text.split(" ");
      const lines = [];
      let line = "";

      for (const word of words) {
        const testLine = line ? line + " " + word : word;
        const width = font.widthOfTextAtSize(testLine, fontSize);

        if (width < maxWidth) {
          line = testLine;
        } else {
          if (line) lines.push(line);
          line = word;
        }
      }

      if (line) lines.push(line);

      return lines;
    };

    /* ================= HEADER ================= */

    const drawHeader = () => {
      const pageHeight = page.getHeight();

      let doctorInfoX, doctorInfoY;
      let patientInfoLeftX, patientInfoLeftY;
      let patientInfoRightX, patientInfoRightY;

      let noteX, noteY;

      let fontSizeD = 16;

      if (
        appointment?.doctorId?.whichAppointmentTemplate === "org" ||
        appointment?.doctorId?.whichAppointmentTemplate === "doctor"
      ) {
        patientInfoLeftX = Number(
          appointment?.doctorId?.appointmentTemplate?.patientInfoLeftX,
        );
        patientInfoLeftY =
          pageHeight -
          Number(appointment?.doctorId?.appointmentTemplate?.patientInfoLeftY) -
          10;

        patientInfoRightX = Number(
          appointment?.doctorId?.appointmentTemplate?.patientInfoRightX,
        );
        patientInfoRightY =
          pageHeight -
          Number(
            appointment?.doctorId?.appointmentTemplate?.patientInfoRightY,
          ) -
          10;

        doctorInfoX = Number(
          appointment?.doctorId?.appointmentTemplate?.doctorX,
        );
        doctorInfoY =
          pageHeight -
          Number(appointment?.doctorId?.appointmentTemplate?.doctorY) -
          13;
      }

      /* Doctor Info */

      if (appointment?.doctorId?.appointmentTemplate?.doctorInfo === "yes") {
        page.drawText(appointment?.doctorId?.name || "", {
          x: doctorInfoX,
          y: doctorInfoY,
          size: fontSizeD,
          font: boldFont,
          color: rgb(0.58, 0.212, 0.204),
        });

        doctorInfoY -= 15;

        appointment?.doctorId?.qualifications?.forEach((q) => {
          page.drawText(q, {
            x: doctorInfoX,
            y: doctorInfoY,
            size: fontSizeD - 5,
            font: boldFont,
          });
          doctorInfoY -= 15;
        });
      }

      /* Notes */

      if (appointment?.doctorId?.appointmentTemplate?.doctorNote === "yes") {
        if (appointment?.doctorId?.note) {
          page.drawText(appointment?.doctorId?.note, {
            x: noteX,
            y: noteY,
            size: fontSizeD - 7,
            font: boldFont,
          });
        }
      }

      if (appointment?.doctorId?.appointmentTemplate?.appNote === "yes") {
        if (appointment?.note) {
          page.drawText(appointment?.note, {
            x: noteX,
            y: noteY - 15,
            size: fontSizeD - 7,
            font: boldFont,
          });
        }
      }

      let fontSize = 11;

      console.log("appointment", appointment);
      page.drawText(appointment?.patientId?.name || "-", {
        x: patientInfoLeftX,
        y: patientInfoLeftY,
        size: fontSize + 1,
        font: boldFont,
      });

      page.drawText("UHID: " + (appointment?.patientId?.patientID || "-"), {
        x: patientInfoRightX,
        y: patientInfoRightY,
        size: fontSize + 1,
        font: boldFont,
      });

      patientInfoLeftY -= 15;
      patientInfoRightY -= 15;

      page.drawText(
        "Sex/Age: " +
          appointment?.patientId?.gender +
          " / " +
          calculateAge(appointment?.patientId?.dob),
        {
          x: patientInfoLeftX,
          y: patientInfoLeftY,
          size: fontSize - 1,
          font,
        },
      );

      page.drawText("Appointment ID: " + appointment?.appointmentId, {
        x: patientInfoRightX,
        y: patientInfoRightY,
        size: fontSize - 1,
        font,
      });

      patientInfoLeftY -= 15;
      patientInfoRightY -= 15;

      page.drawText("Mobile: " + appointment?.patientId?.mobile, {
        x: patientInfoLeftX,
        y: patientInfoLeftY,
        size: fontSize - 1,
        font,
      });

      page.drawText("Appointment Date: " + formatDate(appointment?.appDate), {
        x: patientInfoRightX,
        y: patientInfoRightY,
        size: fontSize - 1,
        font,
      });
    };

    drawHeader();
    y = CONTENT_START_Y;

    /* ================= VITALS ================= */

    page.drawText("Vitals", { x: startX, y, size: 13, font: boldFont });
    y -= 18;

    const vitals = prescription.vitals || {};

    page.drawText(`Height: ${vitals.height || "-"}`, {
      x: startX,
      y,
      size: 11,
      font,
    });
    page.drawText(`Weight: ${vitals.weight || "-"}`, {
      x: startX + 130,
      y,
      size: 11,
      font,
    });
    page.drawText(`Pulse: ${vitals.pulse || "-"}`, {
      x: startX + 260,
      y,
      size: 11,
      font,
    });
    page.drawText(`BP: ${vitals.bp || "-"}`, {
      x: startX + 390,
      y,
      size: 11,
      font,
    });

    drawDivider();

    /* ================= MEDICAL HISTORY ================= */

    // page.drawText("Medical History", {
    //   x: startX,
    //   y,
    //   size: 13,
    //   font: boldFont,
    // });
    // y -= 16;

    // for (const s of prescription.symptoms || []) {
    //   await ensureSpace();
    //   page.drawText(`• ${s}`, { x: startX + 10, y, size: 11, font });
    //   y -= 14;
    // }
    page.drawText("Medical History", {
      x: startX,
      y,
      size: 13,
      font: boldFont,
    });
    y -= 16;

    const historyText = (prescription.symptoms || [])
      .map((s, i) => `${s}`)
      .join(", ");

    const historyLines = wrapTextByWidth(historyText, font, 11, CONTENT_WIDTH);

    for (const line of historyLines) {
      await ensureSpace();
      page.drawText(line, {
        x: startX + 10,
        y,
        size: 11,
        font,
      });
      y -= 14;
    }

    drawDivider();

    /* ================= INVESTIGATIONS ================= */

    // page.drawText("Investigations Needed", {
    //   x: startX,
    //   y,
    //   size: 13,
    //   font: boldFont,
    // });
    // y -= 16;

    // for (const test of prescription.investigations || []) {
    //   await ensureSpace();
    //   const name = test.isCustom ? test.testName : test.testId?.testName;
    //   page.drawText(`• ${name}`, { x: startX + 10, y, size: 11, font });
    //   y -= 14;
    // }
    page.drawText("Investigations Needed", {
      x: startX,
      y,
      size: 13,
      font: boldFont,
    });
    y -= 16;

    const investigationText = (prescription.investigations || [])
      .map((test, i) => {
        const name = test.isCustom ? test.testName : test.testId?.testName;
        return `${name}`;
      })
      .join(", ");
    const wrapText = (text, maxChars = 85) => {
      const words = text.split(" ");
      let lines = [];
      let line = "";
      words.forEach((word) => {
        if ((line + word).length > maxChars) {
          lines.push(line);
          line = word + " ";
        } else {
          line += word + " ";
        }
      });
      lines.push(line);
      return lines;
    };

    const investigationLines = wrapTextByWidth(
      investigationText,
      font,
      11,
      CONTENT_WIDTH,
    );

    for (const line of investigationLines) {
      await ensureSpace();
      page.drawText(line, {
        x: startX + 10,
        y,
        size: 11,
        font,
      });
      y -= 14;
    }

    drawDivider();

    /* ================= MEDICINES ================= */
    // load icons
    const morningBytes = await fetch(morningImg).then((res) =>
      res.arrayBuffer(),
    );
    const afternoonBytes = await fetch(afternoonImg).then((res) =>
      res.arrayBuffer(),
    );
    const eveningBytes = await fetch(eveningImg).then((res) =>
      res.arrayBuffer(),
    );
    const nightBytes = await fetch(nightImg).then((res) => res.arrayBuffer());

    // embed into pdf
    const morningIcon = await pdfDoc.embedPng(morningBytes);
    const afternoonIcon = await pdfDoc.embedPng(afternoonBytes);
    const eveningIcon = await pdfDoc.embedPng(eveningBytes);
    const nightIcon = await pdfDoc.embedPng(nightBytes);

    /* ================= MEDICINES ================= */

    const colMedicine = startX;
    const colMorning = CONTENT_END_X - 260;
    const colAfternoon = CONTENT_END_X - 200;
    const colEvening = CONTENT_END_X - 140;
    const colNight = CONTENT_END_X - 80;

    page.drawText("MEDICINES", {
      x: startX,
      y: y - 9,
      size: 13,
      font: boldFont,
    });
    // y -= 18;

    /* -------- ICON HEADER -------- */

    const iconSize = 20;
    const labelOffset = 14;

    page.drawImage(morningIcon, {
      x: colMorning - 5,
      y: y - 5,
      width: iconSize,
      height: iconSize,
    });

    page.drawImage(afternoonIcon, {
      x: colAfternoon - 5,
      y: y - 5,
      width: iconSize,
      height: iconSize,
    });

    page.drawImage(eveningIcon, {
      x: colEvening - 5,
      y: y - 5,
      width: iconSize,
      height: iconSize,
    });

    page.drawImage(nightIcon, {
      x: colNight - 5,
      y: y - 5,
      width: iconSize,
      height: iconSize,
    });

    /* labels under icons */

    page.drawText("Morning", {
      x: colMorning - 8,
      y: y - labelOffset,
      size: 8,
      font,
    });

    page.drawText("Afternoon", {
      x: colAfternoon - 10,
      y: y - labelOffset,
      size: 8,
      font,
    });

    page.drawText("Evening", {
      x: colEvening - 8,
      y: y - labelOffset,
      size: 8,
      font,
    });

    page.drawText("Night", {
      x: colNight - 4,
      y: y - labelOffset,
      size: 8,
      font,
    });

    y -= 26;

    page.drawLine({
      start: { x: startX, y },
      end: { x: CONTENT_END_X, y },
      thickness: 0.8,
    });

    y -= 16;

    /* -------- MEDICINE ROWS -------- */

    let index = 1;

    for (const med of prescription.medicines || []) {
      await ensureSpace(120);

      /* medicine name */
      page.drawText(`${index}. ${med.medicine}`, {
        x: colMedicine,
        y,
        size: 11,
        font: boldFont,
      });

      /* dosage timing */
      page.drawText(med.morning || "-", { x: colMorning, y, size: 11, font });
      page.drawText(med.afternoon || "-", {
        x: colAfternoon,
        y,
        size: 11,
        font,
      });
      page.drawText(med.evening || "-", { x: colEvening, y, size: 11, font });
      page.drawText(med.night || "-", { x: colNight, y, size: 11, font });

      y -= 14;

      /* duration + note inline */
      const durationText = `${med.duration || ""} ${med.durationType || ""}`;
      const noteText = med.note ? ` | ${med.note}` : "";

      const fullLine = durationText + noteText;

      const availableWidth = CONTENT_END_X - (colMedicine + 15);

      const wrappedLines = wrapTextByWidth(fullLine, font, 10, availableWidth);

      for (const line of wrappedLines) {
        await ensureSpace();

        page.drawText(line, {
          x: colMedicine + 15,
          y,
          size: 10,
          font,
          color: rgb(0.35, 0.35, 0.35),
        });

        y -= 12;
      }

      /* divider */
      page.drawLine({
        start: { x: startX, y },
        end: { x: CONTENT_END_X, y },
        thickness: 0.4,
        color: rgb(0.85, 0.85, 0.85),
      });

      y -= 14;

      index++;
    }

    /* ================= FOOTER ================= */

    page.drawText(
      `Generated: ${new Date(prescription.createdAt).toLocaleString()}`,
      { x: startX, y: 30, size: 9, font, color: rgb(0.5, 0.5, 0.5) },
    );

    /* ================= SAVE ================= */

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url);
  };

  const [printInvoiceLoading, setPrintInvoiceLoading] = useState(false);

  const createApptInvoice = (
    invoice,
    pageSize = "a5",
    orientation = "landscape",
  ) => {
    const doc = new jsPDF({
      orientation: orientation, // 'portrait' or 'landscape' a4, a5
      unit: "mm",
      format: pageSize, // 'a4', 'a5', etc.
    });

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    let space = 35;
    let yPosition = space + 20; // Initial vertical position

    const addHeader = () => {
      doc.setFillColor(255, 255, 255);
      doc.rect(0, 0, pageWidth, 30, "F");
      doc.setFontSize(20);
      doc.setFont("helvetica", "bold");
      doc.text(localStorage.getItem("orgName"), 14, 10);
      doc.setFontSize(10);
      doc.text(localStorage.getItem("orgAddress1"), 14, 15);
      doc.text(localStorage.getItem("orgAddress2"), 14, 20);
      doc.text(
        `Ph. ${localStorage.getItem(
          "orgPhone",
        )} | Email: ${localStorage.getItem("orgEmail")}`,
        14,
        25,
      );
      const imgSrc = localStorage.getItem("orgLogo");
      // "https://res.cloudinary.com/dotuhpjuq/image/upload/v1738647135/organization_logos/igwvnssrrlujapyuv907.jpg"; // Replace with your image URL or base64
      const imgWidth = 50; // Adjust width as needed
      const imgHeight = 30; // Adjust height as needed
      if (imgSrc) doc.addImage(imgSrc, "PNG", 145, 1, imgWidth, imgHeight);
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(10, 30, pageWidth - 10, 30);

      doc.setFontSize(10);
      doc.setTextColor(50, 50, 50);
      doc.setFont("helvetica", "bold");
      doc.text(
        `Patient Name: ${invoice.patientId.name} (${invoice.patientId.patientID})`,
        14,
        space,
      );
      space += 5;
      doc.setFont("helvetica", "normal");
      doc.text(
        `Gender / Age: ${invoice.patientId.gender} / ${calculateAge(
          invoice.patientId.dob,
        )}`,
        14,
        space,
      );
      space += 5;
      doc.text(`Mobile: ${invoice.patientId.mobile}`, 14, space);
      space += 5;
      // doc.text(`Ref. By: ${invoice.doctor.name}`, 14, space);
      // space += 5;
      // doc.text(
      //   `Center: ${invoice.center.centreId}`,
      //   14,
      //   space
      // );
      space = 35;
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 35);
      doc.text(
        `Appointment ID: ${invoice.appointmentId}`,
        pageWidth - 80,
        space,
      );
      space += 5;
      doc.text(`Appointment Date: ${invoice.appDate}`, pageWidth - 80, space);
      space += 5;
      // doc.text(`Time: ${timeStr}`, pageWidth - 80, space);

      // Barcode generation
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, invoice.appointmentId, {
        format: "CODE128",
        width: 2,
        height: 30,
        displayValue: false,
      });
      const barcodeImage = barcodeCanvas.toDataURL("image/png");
      doc.addImage(barcodeImage, "PNG", pageWidth - 83, space - 3, 50, 13);

      //yPosition = 85; // Reset yPosition after header
    };

    const addTableHeader = () => {
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(10, yPosition, pageWidth - 10, yPosition);
      yPosition += 5;

      doc.setFontSize(10);
      doc.setTextColor(0);
      doc.setFont("helvetica", "bold");
      doc.text("Details", 20, yPosition);
      doc.text("Fees (Rs.)", pageWidth - 60, yPosition);
      yPosition += 5;
    };

    const addNewPageIfNeeded = (extraSpace) => {
      if (yPosition + extraSpace > pageHeight - 40) {
        space = 35;
        yPosition = space + 25;
        doc.addPage();
        addHeader();
        addTableHeader();
      }
    };

    // Start document creation
    addHeader();
    addTableHeader();

    // Print all test information
    doc.setFont("helvetica", "normal");
    doc.setTextColor(50, 50, 50);
    doc.text(`Doctor Consultation - ${invoice?.doctorId?.name}`, 20, yPosition);
    doc.text(
      `Rs. ${invoice?.doctorId?.consultFees?.toFixed(2)}`,
      pageWidth - 60,
      yPosition,
    );
    // const testList = invoice?.invoiceSummary?.testList;
    // testList.forEach((test, index) => {
    //   addNewPageIfNeeded(5);
    //   doc.setFont("helvetica", "normal");
    //   doc.setTextColor(50, 50, 50);
    //   doc.text(`${index + 1}. ${test?.testName}`, 20, yPosition);
    //   doc.text(`Rs. ${test.testPrice?.toFixed(2)}`, pageWidth - 60, yPosition);
    //   yPosition += 5;
    // });

    // Print amount details (Footer)
    const addFooter = () => {
      yPosition = pageHeight - 40;

      doc.setLineWidth(0.5);
      doc.line(10, yPosition, pageWidth - 10, yPosition);
      yPosition += 5;

      doc.setFont("helvetica", "bold");

      doc.text("Subtotal:", 20, yPosition);
      doc.text(
        `Rs. ${invoice?.doctorId?.consultFees?.toFixed(2)}`,
        pageWidth - 60,
        yPosition,
      );
      yPosition += 5;

      doc.text("Discount Offered:", 20, yPosition);
      doc.text(
        `Rs. ${invoice?.discount?.toFixed(2) || "0.00"}`,
        pageWidth - 60,
        yPosition,
      );
      yPosition += 5;

      doc.text("Grand Total:", 20, yPosition);
      doc.text(
        `Rs. ${(
          invoice?.doctorId?.consultFees?.toFixed(2) -
          (invoice?.discount?.toFixed(2) || 0.0)
        ).toFixed(2)}`,
        pageWidth - 60,
        yPosition,
      );
      yPosition += 5;

      doc.text("Amount Collected:", 20, yPosition);
      doc.text(
        `Rs. ${invoice?.totalCollected?.toFixed(2) || "0.00"}`,
        pageWidth - 60,
        yPosition,
      );
      yPosition += 5;

      doc.text("Amount Due:", 20, yPosition);
      doc.text(
        `Rs. ${
          (
            invoice?.doctorId?.consultFees +
            invoice?.discount -
            invoice?.totalCollected
          ).toFixed(2) || "0.00"
        }`,
        pageWidth - 60,
        yPosition,
      );
      yPosition += 10;

      // Footer Section
      // doc.setFontSize(8);
      // doc.setFont("helvetica", "italic");
      // doc.setTextColor(100);
      // doc.text(
      //   `Created By: ${invoice.userId.userName} / Last Modified By: ${
      //     invoice.userId.lastModifiedBy || "none"
      //   } / Printed By: ${localStorage.getItem(
      //     "userName"
      //   )} / Last Printed By: ${invoice?.lastInvoicePrintedBy || "none"}`,
      //   20,
      //   yPosition
      // );
    };

    addFooter();

    // Open the PDF in a new tab
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  };

  const printInvoice = async (appt) => {
    setPrintInvoiceLoading(true);
    try {
      // return;
      createApptInvoice(appt);
    } catch (error) {
      alert("Something went wrong! Please try again.");
    } finally {
      setPrintInvoiceLoading(false);
    }
  };

  // State for popover
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  const handleOpen = (event, appointment) => {
    setAnchorEl(event.currentTarget);
    setSelectedAppointment(appointment); // store the appointment that was clicked
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedAppointment(null);
  };

  const open = Boolean(anchorEl);

  const [editingRow, setEditingRow] = useState(null);
  const [amount, setAmount] = useState("");
  const [dateInputVisible, setDateInputVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const amountInputRef = useRef(null);
  const dateInputRef = useRef(null);

  const handleCollectClick = (index) => {
    setEditingRow(index);
    setDateInputVisible(false);
    setTimeout(() => amountInputRef.current?.focus(), 100);
  };

  const handleConfirmAmount = (id) => {
    // setDateInputVisible(true);
    handleAmtSubmit(id, amount);
    // setTimeout(() => dateInputRef.current?.focus(), 100);
  };

  const [amtLoading, setAmtLoading] = useState(false);
  const handleAmtSubmit = async (id, amount) => {
    setAmtLoading(true);
    const data = {
      collected: amount,
    };
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/insert-paid-amt-apt-invoice/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );

      const resp = await response.json();
      if (resp.success) {
        toast.success(resp.message);
        setAmount("");
        setEditingRow(null);
        setAppointments((prevApt) =>
          prevApt.map((apt) => {
            if (apt._id === id) {
              return {
                ...apt,
                totalCollected: resp.apt.totalCollected,
              };
            }
            return apt;
          }),
        );
      } else {
        toast.error("Error: " + resp.message);
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again.");
    } finally {
      setAmtLoading(false);
    }
  };

  const handleCancelInput = () => {
    setEditingRow(null);
    setAmount("");
    setSelectedDate("");
    setDateInputVisible(false);
  };
  return (
    // Tailwind-style visual refresh — same logic/handlers/state as before,
    // restyled entirely with MUI's `sx` prop using a Tailwind-inspired token set:
    //
    //   slate-50  #f8fafc   surfaces / hover
    //   slate-100 #f1f5f9   subtle fills
    //   slate-200 #e2e8f0   borders
    //   slate-500 #64748b   muted text
    //   slate-700 #334155   body text
    //   slate-900 #0f172a   headings
    //   indigo-600 #4f46e5  primary actions
    //   emerald-600 #059669 success
    //   rose-600  #e11d48   danger
    //   amber-500 #f59e0b   warning
    //
    // Radii: 8px (controls) / 12px (cards) / 9999px (pills)
    // Shadows: soft, single-layer (shadow-sm), no heavy drop shadows.

    <Box>
      <TablePagination
        component="div"
        count={filteredAppointments?.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
        sx={{
          color: "#334155",
          fontSize: "0.85rem",
          ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
            {
              fontSize: "0.8rem",
              color: "#64748b",
            },
        }}
      />

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
          backgroundColor: "#ffffff",
        }}
      >
        {/* Toolbar */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1.5,
            p: 2,
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.75,
              backgroundColor: "#ecfdf5", // emerald-50
              borderRadius: "9999px",
              border: "1px solid #a7f3d0", // emerald-200
              px: 1.5,
              py: 0.5,
            }}
          >
            <Typography
              component="span"
              sx={{ color: "#047857", fontSize: "0.8rem", fontWeight: 700 }}
            >
              {appointments.length}
            </Typography>
            <Typography
              sx={{ color: "#047857", fontSize: "0.8rem", fontWeight: 600 }}
            >
              Appointments
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              backgroundColor: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              px: 1.5,
              py: 0.75,
            }}
          >
            <input
              type="date"
              value={fromDate}
              onChange={(e) => {
                setFromDate(e.target.value);
                setFormattedFromDate(
                  formatDateToReadableString(e.target.value),
                );
              }}
              style={{
                padding: "6px 10px",
                fontSize: "13.5px",
                borderRadius: "6px",
                border: "1px solid #e2e8f0",
                outline: "none",
                color: "#334155",
                backgroundColor: "#ffffff",
                transition: "border-color 0.15s ease, box-shadow 0.15s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#6366f1";
                e.target.style.boxShadow = "0 0 0 3px rgba(99,102,241,0.15)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e2e8f0";
                e.target.style.boxShadow = "none";
              }}
            />

            <EastIcon sx={{ fontSize: 16, color: "#94a3b8" }} />

            <input
              type="date"
              value={toDate}
              onChange={(e) => {
                setToDate(e.target.value);
                setFormattedToDate(formatDateToReadableString(e.target.value));
              }}
              style={{
                padding: "6px 10px",
                fontSize: "13.5px",
                borderRadius: "6px",
                border: "1px solid #e2e8f0",
                outline: "none",
                color: "#334155",
                backgroundColor: "#ffffff",
                transition: "border-color 0.15s ease, box-shadow 0.15s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#6366f1";
                e.target.style.boxShadow = "0 0 0 3px rgba(99,102,241,0.15)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e2e8f0";
                e.target.style.boxShadow = "none";
              }}
            />

            {fromDate && toDate && (
              <Button
                variant="contained"
                disableElevation
                onClick={searchByDate}
                sx={{
                  backgroundColor: "#4f46e5", // indigo-600
                  color: "#fff",
                  px: 2,
                  py: 0.6,
                  fontSize: "13px",
                  fontWeight: 600,
                  borderRadius: "6px",
                  textTransform: "none",
                  boxShadow: "none",
                  "&:hover": { backgroundColor: "#4338ca", boxShadow: "none" },
                  "&:active": { transform: "scale(0.98)" },
                }}
              >
                Search
              </Button>
            )}
          </Box>

          <TextField
            placeholder="Search appointments"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearch}
            sx={{
              width: { xs: "100%", sm: 220 },
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                backgroundColor: "#f8fafc",
                fontSize: "13.5px",
                "& fieldset": { borderColor: "#e2e8f0" },
                "&:hover fieldset": { borderColor: "#cbd5e1" },
                "&.Mui-focused fieldset": {
                  borderColor: "#6366f1",
                  borderWidth: "1.5px",
                },
              },
            }}
          />

          <IconButton
            onClick={handleReload}
            size="small"
            sx={{
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              color: "#4f46e5",
              p: 1,
              "&:hover": { backgroundColor: "#eef2ff", borderColor: "#c7d2fe" },
            }}
          >
            <RefreshIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>

        <Table
          sx={{
            borderCollapse: "separate",
            borderSpacing: 0,
            backgroundColor: "#ffffff",
          }}
        >
          <TableHead
            sx={{
              backgroundColor: "#f8fafc",
              "& .MuiTableCell-head": {
                fontWeight: 700,
                fontSize: "12px",
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                padding: "12px 14px",
                borderBottom: "1px solid #e2e8f0",
              },
            }}
          >
            <TableRow>
              <TableCell>Apt. ID</TableCell>
              <TableCell>Patient Name</TableCell>
              <TableCell>Doctor Name</TableCell>
              <TableCell>Center Name</TableCell>
              <TableCell>Apt. Date</TableCell>
              <TableCell>Fees</TableCell>
              <TableCell>Due</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
            {(loading || pressLoading) && (
              <TableRow>
                <TableCell colSpan={9} sx={{ padding: 0, border: "none" }}>
                  <LinearProgress
                    sx={{
                      height: 2,
                      width: "100%",
                      backgroundColor: "#e2e8f0",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "#4f46e5",
                      },
                    }}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableHead>

          <TableBody>
            {paginatedAppointments?.map((appointment, index) => (
              <TableRow
                key={index}
                sx={{
                  "& .MuiTableCell-root": {
                    borderBottom: "1px solid #f1f5f9",
                    padding: "12px 14px",
                    fontSize: "13.5px",
                    color: "#334155",
                  },
                  "&:hover": { backgroundColor: "#f8fafc" },
                  transition: "background-color 0.15s ease",
                }}
              >
                <TableCell>
                  <Box
                    component="span"
                    sx={{
                      color: "#4338ca", // indigo-700
                      backgroundColor: "#eef2ff", // indigo-50
                      border: "1px solid #c7d2fe",
                      px: 1,
                      py: 0.4,
                      borderRadius: "6px",
                      fontSize: "0.72rem",
                      fontWeight: 700,
                      letterSpacing: "0.02em",
                      display: "inline-block",
                    }}
                  >
                    {appointment?.appointmentId}
                  </Box>
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: "#0f172a" }}>
                  {appointment?.patientId?.name}
                </TableCell>
                <TableCell>{appointment?.doctorId?.name}</TableCell>
                <TableCell>{appointment?.centreId?.centreName}</TableCell>
                <TableCell>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        color: "#ea580c", // orange-600
                        fontSize: "0.85rem",
                        lineHeight: 1.2,
                      }}
                    >
                      {appointment?.appDate || "—"}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell>{appointment?.doctorId?.consultFees}</TableCell>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    color:
                      appointment?.doctorId?.consultFees +
                        appointment?.discount -
                        appointment?.totalCollected >
                      0
                        ? "#e11d48" // rose-600 — still owed
                        : "#059669", // emerald-600 — settled
                  }}
                >
                  {appointment?.doctorId?.consultFees +
                    appointment?.discount -
                    appointment?.totalCollected}
                </TableCell>
                {/* {!["completed"].includes(appointment?.appointmentStatus) ? (
                  <TableCell sx={{ minWidth: 205 }}>
                    {(() => {
                      const statusKey = getAppointmentStatus(appointment);
                      const status = APPOINTMENT_STATUSES[statusKey];
                      const updating = statusUpdatingId === appointment._id;
                      return (
                        <FormControl size="small" fullWidth disabled={updating}>
                          <Select
                            value={statusKey}
                            onChange={(event) =>
                              updateAppointmentStatus(
                                appointment,
                                event.target.value,
                              )
                            }
                            renderValue={(value) => {
                              const selected = APPOINTMENT_STATUSES[value];
                              return (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.75,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 7,
                                      height: 7,
                                      borderRadius: "50%",
                                      bgcolor: selected.color,
                                    }}
                                  />
                                  <Typography
                                    sx={{
                                      fontSize: "0.76rem",
                                      fontWeight: 700,
                                      color: selected.color,
                                    }}
                                  >
                                    {selected.shortLabel}
                                  </Typography>
                                </Box>
                              );
                            }}
                            sx={{
                              bgcolor: status.background,
                              color: status.color,
                              borderRadius: "8px",
                              fontSize: "0.8rem",
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: status.border,
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: status.color,
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: status.color,
                                  borderWidth: "1.5px",
                                },
                            }}
                          >
                            {Object.entries(APPOINTMENT_STATUSES).map(
                              ([key, option]) => (
                                <MenuItem key={key} value={key}>
                                  <Box>
                                    <Typography
                                      sx={{
                                        fontSize: "0.82rem",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {option.label}
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      sx={{ color: "#94a3b8" }}
                                    >
                                      Stage{" "}
                                      {Object.keys(
                                        APPOINTMENT_STATUSES,
                                      ).indexOf(key) + 1}
                                    </Typography>
                                  </Box>
                                </MenuItem>
                              ),
                            )}
                          </Select>
                        </FormControl>
                      );
                    })()}
                  </TableCell>
                ) : (
                  <TableCell>
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.6,

                        px: 1.2,
                        py: 0.45,

                        borderRadius: "999px",

                        bgcolor: "#ecfdf5",
                        border: "1px solid #a7f3d0",

                        color: "#047857",
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{
                          fontSize: ".8rem",
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: ".68rem",
                          fontWeight: 700,
                          lineHeight: 1,
                        }}
                      >
                        Completed
                      </Typography>
                    </Box>
                  </TableCell>
                )} */}
                {!["completed"].includes(appointment?.appointmentStatus) ? (
                  <TableCell sx={{ minWidth: 205 }}>
                    {(() => {
                      const statusKey = getAppointmentStatus(appointment);
                      const status = APPOINTMENT_STATUSES[statusKey];
                      const updating = statusUpdatingId === appointment._id;

                      const isPending = statusKey === "pending";

                      return (
                        <FormControl size="small" fullWidth disabled={updating}>
                          <Select
                            /*
                             * For pending we still keep the Select value as "pending"
                             * so the dropdown shows On Hold.
                             */
                            value={statusKey}
                            onChange={(event) =>
                              updateAppointmentStatus(
                                appointment,
                                event.target.value,
                              )
                            }
                            renderValue={(value) => {
                              const selected = APPOINTMENT_STATUSES[value];

                              return (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.75,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 7,
                                      height: 7,
                                      borderRadius: "50%",
                                      bgcolor: selected.color,
                                    }}
                                  />

                                  <Typography
                                    sx={{
                                      fontSize: "0.76rem",
                                      fontWeight: 700,
                                      color: selected.color,
                                    }}
                                  >
                                    {selected.shortLabel}
                                  </Typography>
                                </Box>
                              );
                            }}
                            sx={{
                              bgcolor: status.background,
                              color: status.color,
                              borderRadius: "8px",
                              fontSize: "0.8rem",

                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: status.border,
                              },

                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: status.color,
                              },

                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: status.color,
                                  borderWidth: "1.5px",
                                },
                            }}
                          >
                            {isPending ? (
                              /*
                               * ================================
                               * PENDING
                               * ================================
                               *
                               * Current value: On Hold
                               * Only available action: Send to Consult
                               */
                              <MenuItem value="in_consult">
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "0.82rem",
                                      fontWeight: 700,
                                      color: "#047857",
                                    }}
                                  >
                                    Send to Consult
                                  </Typography>

                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#94a3b8",
                                    }}
                                  >
                                    Resume patient consultation
                                  </Typography>
                                </Box>
                              </MenuItem>
                            ) : (
                              /*
                               * ================================
                               * NORMAL STATUS
                               * ================================
                               *
                               * Keep the existing behavior.
                               */
                              Object.entries(APPOINTMENT_STATUSES)
                                .filter(([key]) => key !== "pending")
                                .map(([key, option]) => (
                                  <MenuItem key={key} value={key}>
                                    <Box>
                                      <Typography
                                        sx={{
                                          fontSize: "0.82rem",
                                          fontWeight: 700,
                                        }}
                                      >
                                        {option.label}
                                      </Typography>

                                      <Typography
                                        variant="caption"
                                        sx={{
                                          color: "#94a3b8",
                                        }}
                                      >
                                        Stage{" "}
                                        {Object.entries(APPOINTMENT_STATUSES)
                                          .filter(([key]) => key !== "pending")
                                          .map(([key]) => key)
                                          .indexOf(key) + 1}
                                      </Typography>
                                    </Box>
                                  </MenuItem>
                                ))
                            )}
                          </Select>
                        </FormControl>
                      );
                    })()}
                  </TableCell>
                ) : (
                  <TableCell>
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.6,

                        px: 1.2,
                        py: 0.45,

                        borderRadius: "999px",

                        bgcolor: "#ecfdf5",
                        border: "1px solid #a7f3d0",

                        color: "#047857",
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{
                          fontSize: ".8rem",
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: ".68rem",
                          fontWeight: 700,
                          lineHeight: 1,
                        }}
                      >
                        Completed
                      </Typography>
                    </Box>
                  </TableCell>
                )}

                <TableCell>
                  {editingRow == index ? (
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <input
                        type="number"
                        value={amount}
                        onChange={(e) => {
                          if (
                            e.target.value >
                            appointment?.doctorId?.consultFees +
                              appointment?.discount -
                              appointment?.collected
                          ) {
                            return;
                          }
                          setAmount(e.target.value);
                        }}
                        placeholder="Enter amount"
                        style={{
                          width: "120px",
                          padding: "6px 10px",
                          fontSize: "13.5px",
                          borderRadius: "6px",
                          border: "1px solid #a7f3d0",
                          outline: "none",
                          backgroundColor: "#ecfdf5",
                          color: "#047857",
                          transition:
                            "border-color 0.15s ease, box-shadow 0.15s ease",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#059669";
                          e.target.style.boxShadow =
                            "0 0 0 3px rgba(5,150,105,0.15)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#a7f3d0";
                          e.target.style.boxShadow = "none";
                        }}
                      />

                      {amtLoading ? (
                        <CircularProgress size={20} sx={{ color: "#4f46e5" }} />
                      ) : (
                        <>
                          {amount > 0 && (
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleConfirmAmount(appointment?._id)
                              }
                              sx={{
                                color: "#059669",
                                "&:hover": { backgroundColor: "#ecfdf5" },
                              }}
                            >
                              <CheckIcon fontSize="small" />
                            </IconButton>
                          )}
                          <IconButton
                            size="small"
                            onClick={handleCancelInput}
                            sx={{
                              color: "#e11d48",
                              "&:hover": { backgroundColor: "#fff1f2" },
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </>
                      )}
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Tooltip title="Print options" arrow placement="top">
                        <IconButton
                          onClick={(e) => handleOpen(e, appointment)}
                          size="small"
                          sx={{
                            color: "#db2777", // pink-600
                            "&:hover": { backgroundColor: "#fdf2f8" },
                          }}
                        >
                          <PrintIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>

                      <Popover
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                        slotProps={{
                          paper: {
                            sx: {
                              borderRadius: "10px",
                              border: "1px solid #e2e8f0",
                              boxShadow: "0 8px 24px rgba(15,23,42,0.08)",
                              mt: 0.5,
                            },
                          },
                        }}
                      >
                        <List sx={{ p: 1, minWidth: 240 }}>
                          {user?._doc?.permissions
                            ?.digitalPrescriptionManagement?.view && (
                            <ListItemButton
                              onClick={() =>
                                printDigitalPress(selectedAppointment)
                              }
                              disabled={printing}
                              sx={{
                                borderRadius: "8px",
                                "&:hover": { backgroundColor: "#f8fafc" },
                              }}
                            >
                              <DocumentScannerIcon
                                fontSize="small"
                                sx={{ mr: 1, color: "#7c3aed" }}
                              />
                              <ListItemText
                                primary={
                                  printing
                                    ? "Printing..."
                                    : "Digital prescription"
                                }
                                primaryTypographyProps={{ fontSize: "0.85rem" }}
                              />
                            </ListItemButton>
                          )}

                          <ListItemButton
                            onClick={() => {
                              printPress(selectedAppointment, 1);
                              handleClose();
                            }}
                            sx={{
                              borderRadius: "8px",
                              "&:hover": { backgroundColor: "#f8fafc" },
                            }}
                          >
                            <DifferenceIcon
                              fontSize="small"
                              sx={{ mr: 1, color: "#4f46e5" }}
                            />
                            <ListItemText
                              primary="Prescription with template"
                              primaryTypographyProps={{ fontSize: "0.85rem" }}
                            />
                          </ListItemButton>

                          <ListItemButton
                            onClick={() => {
                              printPress(selectedAppointment, 0);
                              handleClose();
                            }}
                            sx={{
                              borderRadius: "8px",
                              "&:hover": { backgroundColor: "#f8fafc" },
                            }}
                          >
                            <ContentCopyIcon
                              fontSize="small"
                              sx={{ mr: 1, color: "#e11d48" }}
                            />
                            <ListItemText
                              primary="Prescription without template"
                              primaryTypographyProps={{ fontSize: "0.85rem" }}
                            />
                          </ListItemButton>

                          <ListItemButton
                            onClick={() => {
                              printInvoice(selectedAppointment);
                              handleClose();
                            }}
                            sx={{
                              borderRadius: "8px",
                              "&:hover": { backgroundColor: "#f8fafc" },
                            }}
                          >
                            <ReceiptIcon
                              fontSize="small"
                              sx={{ mr: 1, color: "#059669" }}
                            />
                            <ListItemText
                              primary="Invoice"
                              primaryTypographyProps={{ fontSize: "0.85rem" }}
                            />
                          </ListItemButton>
                        </List>
                      </Popover>

                      <Tooltip title="Collect" arrow placement="top">
                        <IconButton
                          size="small"
                          onClick={() => handleCollectClick(index)}
                          sx={{
                            color: "#059669",
                            "&:hover": { backgroundColor: "#ecfdf5" },
                          }}
                        >
                          <PointOfSaleIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>

                      {[
                        "in_consult",
                        "completed",
                        "booked",
                        "pending",
                      ].includes(appointment?.appointmentStatus) ? (
                        ""
                      ) : (
                        <Tooltip
                          title="Record patient vitals"
                          arrow
                          placement="top"
                        >
                          <IconButton
                            size="small"
                            onClick={() => openVitalsDialog(appointment)}
                            sx={{
                              color: "#4f46e5",
                              "&:hover": { backgroundColor: "#eef2ff" },
                            }}
                          >
                            <MonitorHeartIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}

                      {user?._doc?.permissions?.opdManagement?.delete && (
                        <Tooltip
                          title="Delete appointment"
                          arrow
                          placement="top"
                        >
                          <IconButton
                            size="small"
                            onClick={() => handleDelete(appointment._id)}
                            sx={{
                              color: "#e11d48",
                              "&:hover": { backgroundColor: "#fff1f2" },
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}

                      {/* {user?._doc?.permissions?.digitalPrescriptionManagement
                        ?.edit && (
                        <Tooltip
                          title="Edit digital prescription"
                          arrow
                          placement="top"
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleEditDigitalPress(appointment._id)
                            }
                            sx={{
                              color: "#4f46e5",
                              "&:hover": { backgroundColor: "#eef2ff" },
                            }}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )} */}
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Vitals dialog */}
      <Dialog
        open={Boolean(vitalsAppointment)}
        onClose={closeVitalsDialog}
        fullWidth
        maxWidth="sm"
        slotProps={{
          paper: {
            sx: {
              borderRadius: "14px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 20px 40px rgba(15,23,42,0.12)",
            },
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: "#0f172a" }}>
          Record patient vitals
          <Typography
            component="span"
            variant="body2"
            sx={{ display: "block", mt: 0.4, color: "#64748b" }}
          >
            {vitalsAppointment?.patientId?.name || "Patient"} ·{" "}
            {vitalsAppointment?.appointmentId || "Appointment"}
          </Typography>
        </DialogTitle>

        <DialogContent dividers sx={{ borderColor: "#f1f5f9" }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 2,
              pt: 0.5,
            }}
          >
            {[
              {
                label: "Height",
                key: "height",
                placeholder: "e.g. 170",
                unit: "cm",
              },
              {
                label: "Weight",
                key: "weight",
                placeholder: "e.g. 65",
                unit: "kg",
              },
              {
                label: "Pulse",
                key: "pulse",
                placeholder: "e.g. 72",
                unit: "bpm",
              },
            ].map((field) => (
              <TextField
                key={field.key}
                label={field.label}
                value={vitals[field.key]}
                onChange={(event) =>
                  setVitals((current) => ({
                    ...current,
                    [field.key]: event.target.value,
                  }))
                }
                placeholder={field.placeholder}
                InputProps={{
                  endAdornment: (
                    <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                      {field.unit}
                    </Typography>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "& fieldset": { borderColor: "#e2e8f0" },
                    "&:hover fieldset": { borderColor: "#cbd5e1" },
                    "&.Mui-focused fieldset": { borderColor: "#4f46e5" },
                  },
                }}
              />
            ))}
            <TextField
              label="Blood pressure"
              value={vitals.bp}
              onChange={(event) =>
                setVitals((current) => ({ ...current, bp: event.target.value }))
              }
              placeholder="e.g. 120/80"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  "& fieldset": { borderColor: "#e2e8f0" },
                  "&:hover fieldset": { borderColor: "#cbd5e1" },
                  "&.Mui-focused fieldset": { borderColor: "#4f46e5" },
                },
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={closeVitalsDialog}
            disabled={savingVitals}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              color: "#64748b",
              borderRadius: "8px",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disableElevation
            onClick={saveVitals}
            disabled={savingVitals}
            startIcon={
              savingVitals ? (
                <CircularProgress size={16} sx={{ color: "#fff" }} />
              ) : (
                <MonitorHeartIcon />
              )
            }
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "8px",
              backgroundColor: "#4f46e5",
              boxShadow: "none",
              "&:hover": { backgroundColor: "#4338ca", boxShadow: "none" },
            }}
          >
            {savingVitals
              ? "Saving..."
              : vitalsAppointment?.hasVitals
                ? "Update Vitals"
                : "Save vitals"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AppointmentList;
